/**
 *      culguraGforma.js
 *          Script de culturaGforma.vue
 *          Valida los valres ingresados, calcula los resultados y genera la grafica en un PDF.
 */

/* ======================================================================================================== */    
import moment from 'moment'    
import ingreso from './ingreso.vue'

import Vue          from 'vue';
import jsPDF from 'jspdf'
    Vue.use(jsPDF)

// import {store}          from './../store'
import {store}      from './../store/store'

// import 'materialize-css/dist/css/materialize.min.css'
import M from 'materialize-css'

export default {
    name: 'datosencuesta',
    components:{
        'moment': moment,
        'input-date': ingreso,
    },
    // props: ['caso','modoviejo','modonuevo'],
    template:  `#formaEncuesta`,
    // props: ['casopar'],
    data(){
        return{
            caso: {},
            modo: "", 
        } // return
    }, // data()
    mounted(){

        /** Definiciones para el uso de los slides y tooltips */
        var elems       = document.querySelectorAll('.collapsible');
        var instances   = M.Collapsible.init(elems, {});            

        var elems = document.querySelectorAll('.tooltipped');
        var instances = M.Tooltip.init(elems, {});

        /** obtiene localmente el caso definido en el almacén (store) */
        this.cargaCaso();
    },
    computed: {
        sumaA(){ return (this.caso.g1pg1 + this.caso.g2pg1 + this.caso.g3pg1 + this.caso.g4pg1 + this.caso.g5pg1 + this.caso.g6pg1); },
        promedioA(){ 
            var lprom = this.sumaA / 6;
            return(lprom.toFixed(2));
        },
        sumaB(){ return (this.caso.g1pg2 + this.caso.g2pg2 + this.caso.g3pg2 + this.caso.g4pg2 + this.caso.g5pg2 + this.caso.g6pg2); },
        promedioB(){ 
            var lprom = this.sumaB / 6;
            return (lprom.toFixed(2)); 
        },
        sumaC(){ return (this.caso.g1pg3 + this.caso.g2pg3 + this.caso.g3pg3 + this.caso.g4pg3 + this.caso.g5pg3 + this.caso.g6pg3); },
        promedioC(){ 
            var lprom = this.sumaC / 6;
            return (lprom.toFixed(2)); 
        },
        sumaD(){ return (this.caso.g1pg4 + this.caso.g2pg4 + this.caso.g3pg4 + this.caso.g4pg4 + this.caso.g5pg4 + this.caso.g6pg4); },
        promedioD(){ 
            var lprom = this.sumaD / 6;
            return (lprom.toFixed(2)); 
        },
        totalG1(){ 
            var lTotal = Number(this.caso.g1pg1) + Number(this.caso.g1pg2) + Number(this.caso.g1pg3) + Number(this.caso.g1pg4);
            if (lTotal > 100){ lTotal= 100; }
            return lTotal;
        },
        totalG2(){
            var lTotal = Number(this.caso.g2pg1) + Number(this.caso.g2pg2) + Number(this.caso.g2pg3) + Number(this.caso.g2pg4);
            if (lTotal > 100){ lTotal= 100; }
            return lTotal;
        },
        totalG3(){
            var lTotal = Number(this.caso.g3pg1) + Number(this.caso.g3pg2) + Number(this.caso.g3pg3) + Number(this.caso.g3pg4);
            if (lTotal > 100){ lTotal= 100; }
            return lTotal;
        },
        totalG4(){
            var lTotal = Number(this.caso.g4pg1) + Number(this.caso.g4pg2) + Number(this.caso.g4pg3) + Number(this.caso.g4pg4);
            if (lTotal > 100){ lTotal= 100; }
            return lTotal;
        },
        totalG5(){
            var lTotal = Number(this.caso.g5pg1) + Number(this.caso.g5pg2) + Number(this.caso.g5pg3) + Number(this.caso.g5pg4);
            if (lTotal > 100){ lTotal= 100; }
            return lTotal;
        },
        totalG6(){
            var lTotal = Number(this.caso.g6pg1) + Number(this.caso.g6pg2) + Number(this.caso.g6pg3) + Number(this.caso.g6pg4);
            if (lTotal > 100){ lTotal= 100; }
            return lTotal;
        },
    },
    methods:{
        cargaCaso(){
            
            this.modo= store.state.st_modo;
            this.caso= store.state.st_caso;
            // this.caso= this.casopar;

            /** Verifica de donde proviene el llamado de la forma */
            if (this.modo==="INGRESO"){

                this.caso.nombre            = store.state.st_nusuario;
                this.caso.empresa           = store.state.st_empresa;
            } // if()
            // console.log("[culturaGforma.js- cargaCaso], modo ? ",this.modo);
            // console.log("[culturaGforma.js- cargaCaso], this.caso.nombre ? ",this.caso.nombre);
            // console.log("[culturaGforma.js- cargaCaso], this.caso.empresa ? ",this.caso.empresa);
        },
        /** .................... VALIDACIONES  .................... */
        validarValor(valor){
            let lvalor= valor;
            if (valor<1 || valor >100){
                lvalor= 0;
            }
            // console.log("validarValor, lvalor ? ",lvalor);
            return lvalor;
        },
        limpiarCaso(){

            this.caso={
                empresa: "", nombre:"", 
                g1pg1: 0, g1pg2: 0, g1pg3: 0, g1pg4: 0, g1total: 0,
                g2pg1: 0, g2pg2: 0, g2pg3: 0, g2pg4: 0, g2total: 0,
                g3pg1: 0, g3pg2: 0, g3pg3: 0, g3pg4: 0, g3total: 0,
                g4pg1: 0, g4pg2: 0, g4pg3: 0, g4pg4: 0, g4total: 0,
                g5pg1: 0, g5pg2: 0, g5pg3: 0, g5pg4: 0, g5total: 0,
                g6pg1: 0, g6pg2: 0, g6pg3: 0, g6pg4: 0, g6total: 0,
                r1suma: 0, r1prom: 0, r2suma: 0, r2prom: 0,
                r3suma: 0, r3prom: 0, r4suma: 0, r4prom: 0,
            }
        
            /* Variables para un nuevo caso */
            store.state.st_caso= this.caso;
            // this.caso=  store.state.st_caso;
            // console.log("[culturaGforma.js- limpiarCaso], store.state.st_caso ? ",store.state.st_caso);
            // console.log("[culturaGforma.js- limpiarCaso], caso ? ",this.caso);
        },        
        /** .................... ACCIONES EN LA BASE DE DATOS  .................... */
        /* Acciones del Floatting Button: Agregar Encuesta */
            agregarCasoMem(){

                if (this.caso.r1prom > 0 && this.caso.r2prom > 0 &&
                    this.caso.r4prom > 0 && this.caso.r4prom > 0) {

                    var confirma = confirm("[culturaGforma.js- agregarEncuestaMem], Seguro de agregar la prueba de  "+this.caso.nombre.trim()+" ? ");
                    if (confirma === true){
                        
                        store.state.st_casos.push({
                            empresa: this.caso.empresa, nombre: this.caso.nombre,
                            g1pg1: this.caso.g1pg1, g1pg2: this.caso.g1pg2, g1pg3: this.caso.g1pg3, g1pg4: this.caso.g1pg4, g1total: this.caso.g1total,
                            g2pg1: this.caso.g2pg1, g2pg2: this.caso.g2pg2, g2pg3: this.caso.g2pg3, g2pg4: this.caso.g2pg4, g2total: this.caso.g2total,
                            g3pg1: this.caso.g3pg1, g3pg2: this.caso.g3pg2, g3pg3: this.caso.g3pg3, g3pg4: this.caso.g3pg4, g3total: this.caso.g3total,
                            g4pg1: this.caso.g4pg1, g4pg2: this.caso.g4pg2, g4pg3: this.caso.g4pg3, g4pg4: this.caso.g4pg4, g4total: this.caso.g4total,
                            g5pg1: this.caso.g5pg1, g5pg2: this.caso.g5pg2, g5pg3: this.caso.g5pg3, g5pg4: this.caso.g5pg4, g5total: this.caso.g5total,
                            g6pg1: this.caso.g6pg1, g6pg2: this.caso.g6pg2, g6pg3: this.caso.g6pg3, g6pg4: this.caso.g6pg4, g6total: this.caso.g6total,
                            r1suma: this.caso.r1suma, r1prom: this.caso.r1prom, r2suma: this.caso.r2suma, r2prom: this.caso.r2prom,
                            r3suma: this.caso.r3suma, r3prom: this.caso.r3prom, r4suma: this.caso.r4suma, r4prom: this.caso.r4prom,
                                        
                            editing: false,
                        });
                    } // if(confirm)
                } else{
                    alert("Debe ingresar valores !");
                } // if()
                // console.log("[culturaGforma.js- agregarEncuestaMem], store.state.st_casos ? ",store.state.st_casos);
                                
                /* Inicializa las variables que captan los valores para el nuevo fcapturadatos */
                this.limpiarCaso();
            },
        agregarCaso() {

            var confirma = confirm("Seguro de agregar el caso de "+this.caso.nombre.trim() + " ?");
            if (confirma === true){
            
                if (this.caso.r1prom >= 0 && this.caso.r2prom >= 0 &&
                    this.caso.r3prom >= 0 && this.caso.r4prom >= 0) {

                    var dbCasos= store.state.st_dbCasos;
                    // console.log("[culturaGforma.js- agregarCaso], dbCasos ? ",dbCasos);
                    /* Agrega una colección al objeto */
                    dbCasos.push({
                        empresa: this.caso.empresa, nombre: this.caso.nombre,
                        g1pg1: this.caso.g1pg1, g1pg2: this.caso.g1pg2, g1pg3: this.caso.g1pg3, g1pg4: this.caso.g1pg4, g1total: this.caso.g1total,
                        g2pg1: this.caso.g2pg1, g2pg2: this.caso.g2pg2, g2pg3: this.caso.g2pg3, g2pg4: this.caso.g2pg4, g2total: this.caso.g2total,
                        g3pg1: this.caso.g3pg1, g3pg2: this.caso.g3pg2, g3pg3: this.caso.g3pg3, g3pg4: this.caso.g3pg4, g3total: this.caso.g3total,
                        g4pg1: this.caso.g4pg1, g4pg2: this.caso.g4pg2, g4pg3: this.caso.g4pg3, g4pg4: this.caso.g4pg4, g4total: this.caso.g4total,
                        g5pg1: this.caso.g5pg1, g5pg2: this.caso.g5pg2, g5pg3: this.caso.g5pg3, g5pg4: this.caso.g5pg4, g5total: this.caso.g5total,
                        g6pg1: this.caso.g6pg1, g6pg2: this.caso.g6pg2, g6pg3: this.caso.g6pg3, g6pg4: this.caso.g6pg4, g6total: this.caso.g6total,
                        r1suma: this.caso.r1suma, r1prom: this.caso.r1prom, r2suma: this.caso.r2suma, r2prom: this.caso.r2prom,
                        r3suma: this.caso.r3suma, r3prom: this.caso.r3prom, r4suma: this.caso.r4suma, r4prom: this.caso.r4prom,
                                    
                        editing: false,                                        
                    }).then( (data) =>{

                        /* Inicializa las variables que captan los valores para el nuevo fcapturadatos */
                        this.limpiarCaso();

                        var laClave = data.key;
                        // console.log("[culturaGforma- agregarCaso], La clave almacenada es ? ",laClave);
                        alert("Formulario guardado con éxito.")
                    });

                    /* Reordena la lista según criterio de ordenamiento actual */
                    // this.reordenar(this.orderActual);
                } // if()
            } // if (confirma)
            // this.ocultarEncuesta();            
        }, // agregarEncuesta()

                    // Segmento 1, coord[1]: 148,8,8, 85,98,108,116; coord[2]: 144,9,8,82,95,112,120; coord[3]: 140,8,8, 79,92,118,124; coord[4]: 132,8,8, 83,81,118,126
                    ploteoCuadrantesAyB(doc, coord, valores){

                        doc.setFontSize(8);  
                        doc.setFontType("bold");                                    
                        doc.setTextColor(0, 0, 255)                

                        /** [1] = 1a. posición, del centro hacia afuera. */
                        var linea= coord[1].linea; var posIf= linea + coord[1].inc1; var posDf= linea + coord[1].inc2;
                        /** Lado Izquierdo */
                        doc.text(coord[1].p_valI,posIf,cA_p11);  // p_valI= posición_valor lado Izquierdo
                        doc.text(coord[1].p_astI,posIf,cA_a11);  // p_astI= posición_* lado Izquierdo
                        /** Lado Derecho */                        
                        doc.text(coord[1].p_valD,posDf,cB_a11);  // p_valI= posición_valor lado derecho
                        doc.text(coord[1].p_astD,posDf,cB_p11);  // p_astI= posición_* lado derecho

                        /** [2] = 2a. posición, del centro hacia afuera. inc1 = incremento 1. inc2 = incremento 2*/                        
                        var linea= coord[2].linea;  var posIf= linea + coord[2].inc1; var posDf= linea + coord[2].inc2;
                        /** Lado Izquierdo */
                        doc.text(coord[2].p_valI,posIf,cA_p12); 
                        doc.text(coord[2].p_astI,posIf,cA_a12);                         
                        /** Lado Derecho */                        
                        doc.text(coord[2].p_valD,posDf,cB_a12); 
                        doc.text(coord[2].p_astD,posDf,cB_p12);

                        /** [3] = 3a. posición, del centro hacia afuera. inc1 = incremento 1. inc2 = incremento 2*/                                                
                        var linea= coord[3].linea; var posIf= linea + coord[3].inc1; var posDf= linea + coord[3].inc2;
                        /** Lado Izquierdo */                        
                        doc.text(coord[3].p_valI,posIf,cA_p13); 
                        doc.text(coord[3].p_astI,posIf,cA_a13);                         
                        /** Lado Derecho */                        
                        doc.text(coord[3].p_valD,posDf,cB_a13); 
                        doc.text(coord[3].p_astD,posDf,cB_p13)                                            

                        /** [4] = 4a. posición, del centro hacia afuera. inc1 = incremento 1. inc2 = incremento 2*/
                        var linea= coord[4].linea; var posIf= linea + coord[4].inc1; var posDf= linea + coord[4].inc2;
                        /** Lado Izquierdo */                        
                        doc.text(coord[4].p_valI,posIf,cA_p14); 
                        doc.text(coord[4].p_astI,posIf,cA_a14); 
                        
                        doc.text(coord[4].p_valD,posDf,cB_p14); 
                        doc.text(coord[4].p_astD,posDf,cB_a14);
                    },
                    ploteoCuadranteAyBSeg1(doc,
                                            cA_a11,cA_p11,cA_a12,cA_p12,cA_a13,cA_p13,cA_a14,cA_p14,
                                            cB_a11,cB_p11,cB_a12,cB_p12,cB_a13,cB_p13,cB_a14,cB_p14){
                        doc.setFontSize(8);  
                        doc.setFontType("bold");                                    
                        doc.setTextColor(0, 0, 255)                
                        // cA_a11="*"; cA_p11= "2.25"; cB_a11="*"; cB_p11= "2.35";
                        // cA_a12="*"; cA_p12= "4.25"; cB_a12="*"; cB_p12= "4.35";
                        // cA_a13="*"; cA_p13= "8.25"; cB_a13="*"; cB_p13= "8.35";
                        // cA_a14="*"; cA_p14= "10.25"; cB_a14="*"; cB_p14= "10.35";                                        
                        var linea= 148; var posIf= linea + 8; var posDf= linea + 8;                 
                        doc.text(85,posIf,cA_p11); doc.text(98,posIf,cA_a11); doc.text(108,posDf,cB_a11); doc.text(116,posDf,cB_p11)                                            

                        var linea= 144;  var posIf= linea + 9; var posDf= linea + 8;                 
                        doc.text(82,posIf,cA_p12); doc.text(95,posIf,cA_a12); doc.text(112,posDf,cB_a12); doc.text(120,posDf,cB_p12)                                            

                        var linea= 140; var posIf= linea + 8; var posDf= linea + 8;                 
                        doc.text(79,posIf,cA_p13); doc.text(92,posIf,cA_a13); doc.text(118,posDf,cB_a13); doc.text(124,posDf,cB_p13)                                            

                        var linea= 132; var posIf= linea + 8; var posDf= linea + 8;                 
                        doc.text(81,posIf,cA_a14); doc.text(83,posIf,cA_p14); doc.text(118,posDf,cB_p14); doc.text(126,posDf,cB_a14);
                        
                        doc.setFontSize(9);  
                        doc.setFontType("normal");
                        doc.setTextColor(0,0,0)        
                    },
                    ploteoCuadranteAyBSeg2(doc,
                        cA_a21,cA_p21,cA_a22,cA_p22,cA_a23,cA_p23,cA_a24,cA_p24,
                        cB_a21,cB_p21,cB_a22,cB_p22,cB_a23,cB_p23,cB_a24,cB_p24){
        
                        doc.setFontSize(8);  
                        doc.setFontType("bold");                                    
                        doc.setTextColor(0, 0, 255)                
                        // cA_a21="*"; cA_p21= "13.25"; cB_a21="*"; cB_p21= "13.35";
                        // cA_a22="*"; cA_p22= "15.25"; cB_a22="*"; cB_p22= "15.35";
                        // cA_a23="*"; cA_p23= "22.25"; cB_a23="*"; cB_p23= "22.35";
                        // cA_a24="*"; cA_p24= "26.25"; cB_a24="*"; cB_p24= "26.35";
                        
                        var linea= 106; var posIf= linea + 7; var posDf= linea + 8;    
                        doc.text(55,posIf,cA_a24); doc.text(59,posIf,cA_p24); doc.text(148,posDf,cB_p24); doc.text(157,posDf,cB_a24);

                        var linea= 113;  var posIf= linea + 5; var posDf= linea + 7;
                        doc.text(61,posIf,cA_a23); doc.text(65,posIf,cA_p23); doc.text(143,posDf,cB_p23); doc.text(152,posDf,cB_a23)                                            
                            
                        var linea= 123; var posIf= linea + 5; var posDf= linea + 8;                 
                        doc.text(66,posIf,cA_p22); doc.text(75,posIf,cA_a22); doc.text(131,posDf,cB_p22); doc.text(139,posDf,cB_a22)                                            

                        var linea= 128; var posIf= linea + 5; var posDf= linea + 9;
                        doc.text(69,posIf,cA_p21); doc.text(78,posIf,cA_a21); doc.text(135,posDf,cB_p21); doc.text(132,posDf,cB_a21);

                        doc.setFontSize(9);  
                        doc.setFontType("normal");
                        doc.setTextColor(0,0,0)        
                        },
                        ploteoCuadranteAyBSeg3(doc,
                            cA_a31,cA_p31,cA_a32,cA_p32,cA_a33,cA_p33,cA_a34,cA_p34,
                            cB_a31,cB_p31,cB_a32,cB_p32,cB_a33,cB_p33,cB_a34,cB_p34){
                            // console.log("en ploteo cA_a34 ? ",cA_a34,", valor ? ",cA_p34);
            
                            doc.setFontSize(8);  
                            doc.setFontType("bold");                                    
                            doc.setTextColor(0, 0, 255)                
                            // cA_a31="*"; cA_p31= "31.25"; cB_a31="*"; cB_p31= "31.35";
                            // cA_a32="*"; cA_p32= "33.25"; cB_a32="*"; cB_p32= "33.35";
                            // cA_a33="*"; cA_p33= "36.25"; cB_a33="*"; cB_p33= "36.35";
                            // cA_a34="*"; cA_p34= "38.25"; cB_a34="*"; cB_p34= "38.35";
                                    
                            var linea= 89; var posIf= linea + 7; var posDf= linea + 9;                 
                            doc.text(39,posIf,cA_a34); doc.text(42,posIf,cA_p34); doc.text(163,posDf,cB_p34); doc.text(172,posDf,cB_a34);
            
                            var linea= 94;  var posIf= linea + 5; var posDf= linea + 7;
                            doc.text(42,posIf,cA_a33); doc.text(46,posIf,cA_p33); doc.text(161,posDf,cB_p33); doc.text(169,posDf,cB_a33)                                            
                                
                            var linea= 98; var posIf= linea + 5; var posDf= linea + 8;                 
                            doc.text(36,posIf,cA_p32); doc.text(46,posIf,cA_a32); doc.text(156,posDf,cB_p32); doc.text(164,posDf,cB_a32)                                            
            
                            var linea= 102; var posIf= linea + 5; var posDf= linea + 10;                 
                            doc.text(43,posIf,cA_p31); doc.text(51,posIf,cA_a31); doc.text(164,posDf+1,cB_p31); doc.text(161,posDf,cB_a31);
            
                            doc.setFontSize(9);  
                            doc.setFontType("normal");
                            doc.setTextColor(0,0,0)        
                        },
                        ploteoCuadranteAyBSeg4(doc,
                            cA_a41,cA_p41,cA_a42,cA_p42,
                            cB_a41,cB_p41,cB_a42,cB_p42){
            
                            doc.setFontSize(8);  
                            doc.setFontType("bold");                                    
                            doc.setTextColor(0, 0, 255)                
                            // cA_a41="*"; cA_p41= "41.25"; cB_a41="*"; cB_p41= "41.35";
                            // cA_a42="*"; cA_p42= "44.25"; cB_a42="*"; cB_p42= "44.35";
                            
                            var linea= 85; var posIf= linea + 7; var posDf= linea + 11;           
                            doc.text(37,posIf,cA_a41); doc.text(42,posIf,cA_p41); doc.text(181,posDf,cB_p41); doc.text(176,posDf,cB_a41);
            
                            var linea= 81;  var posIf= linea + 4; var posDf= linea + 8;
                            doc.text(31,posIf,cA_a42); doc.text(33,posIf,cA_p42); doc.text(183,posDf,cB_a42); doc.text(185,posDf,cB_p42)                                            
                                
                            doc.setFontSize(9);  
                            doc.setFontType("normal");
                            doc.setTextColor(0,0,0)        
                        },

            ploteoCuadranteCyDSeg1(doc,
                cC_a11,cC_p11,cC_a12,cC_p12,cC_a13,cC_p13,cC_a14,cC_p14,
                cD_a11,cD_p11,cD_a12,cD_p12,cD_a13,cD_p13,cD_a14,cD_p14){

                doc.setFontSize(8);  
                doc.setFontType("bold");                                    
                doc.setTextColor(0, 0, 255)                
                        
                // cC_a11="*"; cC_p11= "2.25"; cD_a11="*"; cD_p11= "2.35";
                // cC_a12="*"; cC_p12= "4.25"; cD_a12="*"; cD_p12= "4.35";
                // cC_a13="*"; cC_p13= "8.25"; cD_a13="*"; cD_p13= "8.35";
                // cC_a14="*"; cC_p14= "10.25"; cD_a14="*"; cD_p14= "10.35";
                // console.log("ENTRE !");

                var linea= 158; var posIf= linea + 8; var posDf= linea + 8;                 
                doc.text(83,posIf,cC_p11); doc.text(90,posIf,cC_a11); doc.text(112,posDf,cD_a11); doc.text(114,posDf,cD_p11)

                var linea= 161;  var posIf= linea + 8; var posDf= linea + 8;                 
                doc.text(90,posIf,cC_p12); doc.text(87,posIf,cC_a12); doc.text(116,posDf,cD_a12); doc.text(109,posDf,cD_p12)                                            

                var linea= 165; var posIf= linea + 8; var posDf= linea + 8;                 
                doc.text(90,posIf,cC_p13); doc.text(84,posIf,cC_a13); doc.text(122,posDf,cD_a13); doc.text(112,posDf,cD_p13)                                            

                var linea= 167; var posIf= linea + 8; var posDf= linea + 9;                 
                doc.text(82,posIf,cC_a14); doc.text(86,posIf,cC_p14); doc.text(116,posDf,cD_p14); doc.text(124,posDf,cD_a14);

                doc.setFontSize(9);  
                doc.setFontType("normal");
                doc.setTextColor(0,0,0)        
            },
            ploteoCuadranteCyDSeg2(doc,
                cC_a21,cC_p21,cC_a22,cC_p22,cC_a23,cC_p23,cC_a24,cC_p24,
                cD_a21,cD_p21,cD_a22,cD_p22,cD_a23,cD_p23,cD_a24,cD_p24){

                doc.setFontSize(8);  
                doc.setFontType("bold");                                    
                doc.setTextColor(0, 0, 255)                
                        
                // cC_a21="*"; cC_p21= "14.25"; cD_a21="*"; cD_p21= "14.35";
                // cC_a22="*"; cC_p22= "18.25"; cD_a22="*"; cD_p22= "18.35";
                // cC_a23="*"; cC_p23= "22.25"; cD_a23="*"; cD_p23= "22.35";
                // cC_a24="*"; cC_p24= "27.25"; cD_a24="*"; cD_p24= "27.35";
                // console.log("ENTRE !");

                var linea= 177; var posIf= linea + 6; var posDf= linea + 8;       
                doc.text(66,posIf,cC_p21); doc.text(74,posIf,cC_a21); doc.text(135,posDf,cD_a21); doc.text(137,posDf,cD_p21)

                var linea= 181;  var posIf= linea + 8; var posDf= linea + 8;                 
                doc.text(53,posIf,cC_p22); doc.text(63,posIf,cC_a22); doc.text(141,posDf,cD_a22); doc.text(145,posDf,cD_p22)                                            

                var linea= 185; var posIf= linea + 8; var posDf= linea + 11;
                doc.text(58,posIf,cC_p23); doc.text(53,posIf,cC_a23); doc.text(150,posDf,cD_a23); doc.text(154,posDf,cD_p23)                                            

                var linea= 189; var posIf= linea + 8; var posDf= linea + 11;
                doc.text(54,posIf,cC_p24); doc.text(50,posIf,cC_a24); doc.text(145,posDf,cD_p24); doc.text(154,posDf,cD_a24);

                doc.setFontSize(9);  
                doc.setFontType("normal");
                doc.setTextColor(0,0,0)        
            },
            ploteoCuadranteCyDSeg3(doc,
                cC_a31,cC_p31,cC_a32,cC_p32,cC_a33,cC_p33,cC_a34,cC_p34,
                cD_a31,cD_p31,cD_a32,cD_p32,cD_a33,cD_p33,cD_a34,cD_p34){

                doc.setFontSize(8);  
                doc.setFontType("bold");                                    
                doc.setTextColor(0, 0, 255)                
                        
                // cC_a31="*"; cC_p31= "31.25"; cD_a31="*"; cD_p31= "31.35";
                // cC_a32="*"; cC_p32= "33.25"; cD_a32="*"; cD_p32= "33.35";
                // cC_a33="*"; cC_p33= "36.25"; cD_a33="*"; cD_p33= "36.35";
                // cC_a34="*"; cC_p34= "38.25"; cD_a34="*"; cD_p34= "38.35";

                var linea= 198; var posIf= linea + 3; var posDf= linea + 8;                 
                doc.text(37,posIf,cC_p31); doc.text(47,posIf,cC_a31); doc.text(157,posDf,cD_a31); doc.text(159,posDf,cD_p31)

                var linea= 202;  var posIf= linea + 2; var posDf= linea + 7;
                doc.text(33,posIf,cC_p32); doc.text(43,posIf,cC_a32); doc.text(160,posDf,cD_a32); doc.text(164,posDf,cD_p32)                                            

                var linea= 207; var posIf= linea + 1; var posDf= linea + 5;
                doc.text(43,posIf,cC_p33); doc.text(39,posIf,cC_a33); doc.text(163,posDf,cD_a33); doc.text(166,posDf,cD_p33)                                            

                var linea= 211; var posIf= linea + 1; var posDf= linea + 4;
                doc.text(41,posIf,cC_p34); doc.text(36,posIf,cC_a34); doc.text(159,posDf,cD_p34); doc.text(168,posDf,cD_a34);

                doc.setFontSize(9);  
                doc.setFontType("normal");
                doc.setTextColor(0,0,0)        
            },
            ploteoCuadranteCyDSeg4(doc,
                cC_a41,cC_p41,cC_a42,cC_p42,
                cD_a41,cD_p41,cD_a42,cD_p42){

                doc.setFontSize(8);  
                doc.setFontType("bold");                                    
                doc.setTextColor(0, 0, 255)                

                // console.log("ENTRE !");
                // cC_a41="*"; cC_p41="41.25"; cC_a42="*"; cC_p42="50.5"
                // cD_a41="*"; cD_p41="41.55"; cD_a42="*"; cD_p42="51.5"
                // console.log("1a ? ",cC_a41,", 1p ? ",cC_p41);
                // console.log("2a ? ",cC_a42,", 1p ? ",cC_p42);
                // console.log("3a ? ",cD_a41,", 1p ? ",cD_p41);
                // console.log("4a ? ",cD_a42,", 1p ? ",cD_p42);
                
                var linea= 210; var posIf= linea + 6; var posDf= linea + 9;           
                doc.text(33,posIf,cC_a41); doc.text(40,posIf,cC_p41); doc.text(177,posDf,cD_p41); doc.text(173,posDf,cD_a41);

                var linea= 215;  var posIf= linea + 3; var posDf= linea + 7;
                doc.text(27,posIf,cC_a42); doc.text(20,posIf,cC_p42); doc.text(178,posDf,cD_a42); doc.text(180,posDf,cD_p42)                                            
                    
                doc.setFontSize(9);  
                doc.setFontType("normal");
                doc.setTextColor(0,0,0)        
            },

        crearPDF(){

            if (this.caso.r1prom >= 0 && this.caso.r2prom >= 0 &&
                this.caso.r4prom >= 0 && this.caso.r4prom >= 0) {
        
                /** *:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:= 
                 * CUADRANTE A- SEGMENTO 1: del centro hacia afuera. */
                var cA_a11= ""; var cA_p11= ""; var cA_a12= ""; var cA_p12= ""; var cA_a13= ""; var cA_p13= ""; var cA_a14= ""; var cA_p14= "";
                if (this.caso.r1prom <= 3.125) { cA_a11= "*"; cA_p11 = this.caso.r1prom.toString();  } 
                else { if ( this.caso.r1prom >3.125 && this.caso.r1prom<=6.25) { cA_a12= "*"; cA_p12 = this.caso.r1prom.toString();  } 
                    else{  if ( this.caso.r1prom >6.25 && this.caso.r1prom<=9.375) { cA_a13= "*"; cA_p13 = this.caso.r1prom.toString();  } 
                        else if ( this.caso.r1prom >9.375 && this.caso.r1prom<=12.5) { cA_a14= "*"; cA_p14 = this.caso.r1prom.toString(); } 
                    }
                }
                /* CUADRANTE B- SEGMENTO 1: del centro hacia afuera. */
                    var cB_a11= ""; var cB_p11= ""; var cB_a12= ""; var cB_p12= ""; var cB_a13= ""; var cB_p13= ""; var cB_a14= ""; var cB_p14= "";
                    if (this.caso.r2prom <= 3.125) { cB_a11= "*"; cB_p11 = this.caso.r2prom.toString(); } 
                    else {  if ( this.caso.r2prom >3.125 && this.caso.r2prom<=6.25) { cB_a12= "*"; cB_p12 = this.caso.r2prom.toString(); } 
                        else{  if ( this.caso.r2prom >6.25 && this.caso.r2prom<=9.375) { cB_a13= "*"; cB_p13 = this.caso.r2prom.toString();  } 
                            else if ( this.caso.r2prom >9.375 && this.caso.r2prom<=12.5) { cB_a14= "*"; cB_p14 = this.caso.r2prom.toString();  } 
                        }
                    }                
                /* CUADRANTE A- SEGMENTO 2: del centro hacia afuera. */
                var cA_a21= ""; var cA_p21= ""; var cA_a22= ""; var cA_p22= ""; var cA_a23= ""; var cA_p23= ""; var cA_a24= ""; var cA_p24= "";
                if (this.caso.r1prom >12.5 && this.caso.r1prom<=16.88) { cA_a21= "*"; cA_p21 = this.caso.r1prom.toString();  } 
                else { if ( this.caso.r1prom >16.88 && this.caso.r1prom<=21.26) { cA_a22= "*"; cA_p22 = this.caso.r1prom.toString();  } 
                    else{  if ( this.caso.r1prom >21.26 && this.caso.r1prom<=25.63) { cA_a23= "*"; cA_p23 = this.caso.r1prom.toString();  } 
                        else if ( this.caso.r1prom >25.63 && this.caso.r1prom<=30) { cA_a24= "*"; cA_p24 = this.caso.r1prom.toString(); } 
                    }
                }
                /* CUADRANTE B- SEGMENTO 2: del centro hacia afuera. */
                    var cB_a21= ""; var cB_p21= ""; var cB_a22= ""; var cB_p22= ""; var cB_a23= ""; var cB_p23= ""; var cB_a24= ""; var cB_p24= "";
                    if (this.caso.r2prom >12.5 && this.caso.r2prom<=16.88) { cB_a21= "*"; cB_p21 = this.caso.r2prom.toString(); } 
                    else {  if ( this.caso.r2prom >16.88 && this.caso.r2prom<=21.26) { cB_a22= "*"; cB_p22 = this.caso.r2prom.toString(); } 
                        else{  if ( this.caso.r2prom >21.26 && this.caso.r2prom<=25.63) { cB_a23= "*"; cB_p23 = this.caso.r2prom.toString();  } 
                            else if ( this.caso.r2prom >25.63 && this.caso.r2prom<=30) { cB_a24= "*"; cB_p24 = this.caso.r2prom.toString();  } 
                        }
                    }
                    // this.ploteoCuadranteAyBSeg2(doc,
                    //     cA_a21,cA_p21,cA_a22,cA_p22,cA_a23,cA_p23,cA_a24,cA_p24,
                    //     cB_a21,cB_p21,cB_a22,cB_p22,cB_a23,cB_p23,cB_a24,cB_p24);
    
                /** :*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*= */
                /* CUADRANTE B- SEGMENTO 3: del centro hacia afuera. */
                var cA_a31= ""; var cA_p31= ""; var cA_a32= ""; var cA_p32= ""; var cA_a33= ""; var cA_p33= ""; var cA_a34= ""; var cA_p34= "";
                if (this.caso.r1prom >30 && this.caso.r1prom<=32.51) { cA_a31= "*"; cA_p31 = this.caso.r1prom.toString();  } 
                else { if ( this.caso.r1prom >32.51 && this.caso.r1prom<=35.01) { cA_a32= "*"; cA_p32 = this.caso.r1prom.toString();  } 
                    else{  if ( this.caso.r1prom >35.01 && this.caso.r1prom<=37.5) { cA_a33= "*"; cA_p33 = this.caso.r1prom.toString();  } 
                        else if ( this.caso.r1prom >37.5 && this.caso.r1prom<=40) { cA_a34= "*"; cA_p34 = this.caso.r1prom.toString(); } 
                    }
                }
                
                /* CUADRANTE B- SEGMENTO 2: del centro hacia afuera. */
                var cB_a31= ""; var cB_p31= ""; var cB_a32= ""; var cB_p32= ""; var cB_a33= ""; var cB_p33= ""; var cB_a34= ""; var cB_p34= "";
                if (this.caso.r2prom >30 && this.caso.r2prom<=32.51) { cB_a31= "*"; cB_p31 = this.caso.r2prom.toString(); } 
                else {  if ( this.caso.r2prom >32.51 && this.caso.r2prom<=35.01) { cB_a32= "*"; cB_p32 = this.caso.r2prom.toString(); } 
                    else{  if ( this.caso.r2prom >35.01 && this.caso.r2prom<=37.5) { cB_a33= "*"; cB_p33 = this.caso.r2prom.toString();  } 
                        else if ( this.caso.r2prom >37.5 && this.caso.r2prom<=40) { cB_a34= "*"; cB_p34 = this.caso.r2prom.toString();  } 
                    }
                }
                // console.log("en ploteo cA_a34 ? ",cA_a34,", valor ? ",cA_p34);
                
                // this.ploteoCuadranteAyBSeg3(doc,
                //     cA_a31,cA_p31,cA_a32,cA_p32,cA_a33,cA_p33,cA_a34,cA_p34,
                //     cB_a31,cB_p31,cB_a32,cB_p32,cB_a33,cB_p33,cB_a34,cB_p34);                                                
                            /* CUADRANTE B- SEGMENTO 4: del centro hacia afuera. */
                            var cA_a41= ""; var cA_p41= ""; var cA_a42= ""; var cA_p42= ""; var cA_a43= ""; var cA_p43= ""; var cA_a44= ""; var cA_p44= "";
                            if (this.caso.r1prom >40 && this.caso.r1prom<=42.5) { cA_a41= "*"; cA_p41 = this.caso.r1prom.toString();  } 
                            else { 
                                if ( this.caso.r1prom >42.5 ) 
                                    { cA_a42= "*"; cA_p42 = this.caso.r1prom.toString();  } 
                            }    
                            /* CUADRANTE B- SEGMENTO 4: del centro hacia afuera. */
                            var cB_a41= ""; var cB_p41= ""; var cB_a42= ""; var cB_p42= ""; var cB_a43= ""; var cB_p43= ""; var cB_a44= ""; var cB_p44= "";
                            if (this.caso.r2prom >40 && this.caso.r2prom<=42.5) { cB_a41= "*"; cB_p41 = this.caso.r2prom.toString();  } 
                            else { 
                                if ( this.caso.r2prom >42.5 ) 
                                    { cB_a42= "*"; cB_p42 = this.caso.r1prom.toString();  } 
                            }    
                            // console.log("fuera de ploteo, ",cA_a41,cA_p41,cA_a42,cA_p42,cB_a41,cB_p41,cB_a42,cB_p42);                    
                            // this.ploteoCuadranteAyBSeg4(doc,
                            //     cA_a41,cA_p41,cA_a42,cA_p42,
                            //     cB_a41,cB_p41,cB_a42,cB_p42);
            
            /* -*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*                            
            /* CUADRANTE C- SEGMENTO 1: del centro hacia afuera. */
            // this.caso.r1prom= 11.5;
            var cC_a11= ""; var cC_p11= ""; var cC_a12= ""; var cC_p12= ""; var cC_a13= ""; var cC_p13= ""; var cC_a14= ""; var cC_p14= "";
            if (this.caso.r3prom <= 3.125) { cC_a11= "*"; cC_p11 = this.caso.r3prom.toString();  } 
            else { if ( this.caso.r3prom >3.125 && this.caso.r3prom<=6.25) { cC_a11= "*"; cC_p12 = this.caso.r3prom.toString();  } 
                else{  if ( this.caso.r3prom >6.25 && this.caso.r3prom<=9.375) { cC_a13= "*"; cC_p13 = this.caso.r3prom.toString();  } 
                    else if ( this.caso.r3prom >9.375 && this.caso.r3prom<=12.5) { cC_a14= "*"; cC_p14 = this.caso.r3prom.toString(); } 
                }
            }
            
            /* CUADRANTE D- SEGMENTO 1: del centro hacia afuera. */
            // this.caso.r2prom= 11.5;                
            var cD_a11= ""; var cD_p11= ""; var cD_a12= ""; var cD_p12= ""; var cD_a13= ""; var cD_p13= ""; var cD_a14= ""; var cD_p14= "";
            if (this.caso.r4prom <= 3.125) { cD_a11= "*"; cD_p11 = this.caso.r4prom.toString(); } 
            else {  if ( this.caso.r4prom >3.125 && this.caso.r4prom<=6.25) { cD_a12= "*"; cD_p12 = this.caso.r4prom.toString(); } 
                else{  if ( this.caso.r4prom >6.25 && this.caso.r4prom<=9.375) { cD_a13= "*"; cD_p13 = this.caso.r4prom.toString();  } 
                    else if ( this.caso.r4prom >9.375 && this.caso.r4prom<=12.5) { cD_a14= "*"; cD_p14 = this.caso.r4prom.toString();  } 
                }
            }
                    /* CUADRANTE C- SEGMENTO 2: del centro hacia afuera. */
                    // this.caso.r1prom= 11.5;
                    var cC_a21= ""; var cC_p21= ""; var cC_a22= ""; var cC_p22= ""; var cC_a23= ""; var cC_p23= ""; var cC_a24= ""; var cC_p24= "";
                    if (this.caso.r3prom >12.5 && this.caso.r3prom<=16.88) { cC_a21= "*"; cC_p21 = this.caso.r3prom.toString();  } 
                    else { if ( this.caso.r3prom >16.88 && this.caso.r3prom<=21.26) { cC_a21= "*"; cC_p22 = this.caso.r3prom.toString();  } 
                        else{  if ( this.caso.r3prom >21.26 && this.caso.r3prom<=25.63) { cC_a23= "*"; cC_p23 = this.caso.r3prom.toString();  } 
                            else if ( this.caso.r3prom >25.63 && this.caso.r3prom<=30) { cC_a24= "*"; cC_p24 = this.caso.r3prom.toString(); } 
                        }
                    }
                    /* CUADRANTE D- SEGMENTO 2: del centro hacia afuera. */
                    // this.caso.r2prom= 11.5;                
                    var cD_a21= ""; var cD_p21= ""; var cD_a22= ""; var cD_p22= ""; var cD_a23= ""; var cD_p23= ""; var cD_a24= ""; var cD_p24= "";
                    if (this.caso.r4prom >12.5 && this.caso.r4prom<=16.88) { cD_a21= "*"; cD_p21 = this.caso.r4prom.toString(); } 
                    else {  if ( this.caso.r4prom >16.88 && this.caso.r4prom<=21.26) { cD_a22= "*"; cD_p22 = this.caso.r4prom.toString(); } 
                        else{  if ( this.caso.r4prom >21.26 && this.caso.r4prom<=25.63) { cD_a23= "*"; cD_p23 = this.caso.r4prom.toString();  } 
                            else if ( this.caso.r4prom >25.63 && this.caso.r4prom<=30) { cD_a24= "*"; cD_p24 = this.caso.r4prom.toString();  } 
                        }
                    }
                    // console.log("> prom 4 ? ",this.caso.r4prom,"* cC_a32 ? ",cD_a23,", valor ? ",cD_p23);
                    // console.log("> prom 4 ? ",this.caso.r4prom,"* cC_a32 ? ",cD_a24,", valor ? ",cD_p24);

            /* CUADRANTE D- SEGMENTO 1: del centro hacia afuera. */
            var cC_a31= ""; var cC_p31= ""; var cC_a32= ""; var cC_p32= ""; var cC_a33= ""; var cC_p33= ""; var cC_a34= ""; var cC_p34= "";
            if (this.caso.r3prom >30 && this.caso.r3prom<=32.51) { cC_a31= "*"; cC_p31 = this.caso.r3prom.toString();  } 
            else { if ( this.caso.r3prom >32.51 && this.caso.r3prom<=35.01) { cC_a32= "*"; cC_p32 = this.caso.r3prom.toString();  } 
                else{  if ( this.caso.r3prom >35.01 && this.caso.r3prom<=37.5) { cC_a33= "*"; cC_p33 = this.caso.r3prom.toString();  } 
                    else if ( this.caso.r3prom >37.5 && this.caso.r3prom<=40) { cC_a34= "*"; cC_p34 = this.caso.r3prom.toString(); } 
                }
            }
            // console.log("prom 4 ? ",this.caso.r4prom,"* cC_a32 ? ",cC_a33,", valor ? ",cC_p33);
            
            /* CUADRANTE D- SEGMENTO 2: del centro hacia afuera. */
            var cD_a31= ""; var cD_p31= ""; var cD_a32= ""; var cD_p32= ""; var cD_a33= ""; var cD_p33= ""; var cD_a34= ""; var cD_p34= "";
            if (this.caso.r4prom >30 && this.caso.r4prom<=32.51) { cD_a31= "*"; cD_p31 = this.caso.r4prom.toString(); } 
            else {  if ( this.caso.r4prom >32.51 && this.caso.r4prom<=35.01) { cD_a32= "*"; cD_p32 = this.caso.r4prom.toString(); } 
                else{  if ( this.caso.r4prom >35.01 && this.caso.r4prom<=37.5) { cD_a33= "*"; cD_p33 = this.caso.r4prom.toString();  } 
                    else if ( this.caso.r4prom >37.5 && this.caso.r4prom<=40) { cD_a34= "*"; cD_p34 = this.caso.r4prom.toString();  } 
                }
            }
            // console.log("prom 4 ? ",this.caso.r4prom,"* cC_a32 ? ",cD_a33,", valor ? ",cD_p33);

            /* CUADRANTE D- SEGMENTO 3: del centro hacia afuera. */
            var cC_a41= ""; var cC_p41= ""; var cC_a42= ""; var cC_p42= ""; 
            if (this.caso.r3prom >40 && this.caso.r3prom<=42.5) { cC_a41= "*"; cC_p41 = this.caso.r3prom.toString();  } 
            else { 
                if ( this.caso.r3prom >42.5 ) 
                    { cC_a42= "*"; cC_p42 = this.caso.r3prom.toString();  } 
            }
            /* CUADRANTE D- SEGMENTO 4: del centro hacia afuera. */
            var cD_a41= ""; var cD_p41= ""; var cD_a42= ""; var cD_p42= "";
            if (this.caso.r4prom >40 && this.caso.r4prom<=42.5) { cD_a41= "*"; cD_p41 = this.caso.r4prom.toString();  } 
            else { 
                if ( this.caso.r4prom >42.5 ) 
                    { cD_a42= "*"; cD_p42 = this.caso.r4prom.toString();  } 
            }    

            // console.log("prom3 ? ",this.caso.r3prom,", prom4 ? ",this.caso.r4prom);
                                        
                /** Codificación de la imagen que representa el logotipo de Top Consultores */
                var imagen= "data:image/jpeg;base64,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";
                var doc =   new jsPDF('portrait');
                var linea=  5;

                /** Muestra el logo. (izq, top, ancho, alto) */
                doc.addImage(imagen, 'JPEG', 165, linea, 40, 20);
                /** fila, columna */

                /** CIRCULOS  */
                doc.setLineWidth(1);                    // Grosor de la línea del borde
                doc.setDrawColor(0);

                /** ................................................................................................................ 
                /* TEXTO INTRODUCTORIO */
                let meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
                
                var lhoy = new Date();                
                //lhoy=   lhoy.toString();
                var ldia=   lhoy.getDate();
                var lmes=   meses[ lhoy.getMonth() ];
                var lanio=  lhoy.getFullYear();

                // console.log("lhoy ? ",lhoy);
                // console.log("ldia ? ",ldia,", lmes ? ",lmes,", lanio ? ",lanio);
                doc.setFontSize(9);    
                linea=25;
                doc.text(10,linea,"Ciudad de Guatemala, "+ldia+" de "+lmes+" de "+lanio);
                doc.text(10,linea+7,this.caso.nombre)
                doc.text(10,linea+12,this.caso.empresa)
                doc.text(10,linea+19,"");
                doc.text(10,linea+24,"");

                /** ................................................................................................................ 
                /* GRAFICA */
                
                /* El circulo rojo EXTERIOR. (left, bottom, tamaño) */
                linea= 155;                             // **LINEA= 115, 135
                doc.setFillColor(247,189,164);          // Color rosadito
                doc.circle(105, linea, 95, 'FD');       // Ciculo

                /* El circulo azul INTERIOR. (left, bottom, tamaño)*/
                doc.setFillColor(177,203,233);          // Color azul
                doc.circle(104, linea, 70, 'FD');

                /* El circulo rosado INTERIOR. (left, bottom, tamaño) */
                doc.setFillColor(247,189,164);          // Color rosadito
                doc.circle(104, linea, 30, 'FD');
                
                /** ................................................................................................................ 
                 *  FRANJA 1 */ 
                /** Extremo Iquierdo y derecho SUPERIOR */
                linea= 60
                doc.setFontType("bold");                                    
                doc.setFontSize(10);
                doc.text(10, linea, "El Irresponsable"); 
                doc.text(182, linea, "Anarquía"); 
                doc.text(10, linea+5, "Club Campestre"); 
                doc.text(180, linea+5, "tumultuosa"); 
                doc.setFontType("normal");
                doc.setFontSize(9);

                var i=63;
                while (i<=250){

                    let st = ":"+i.toString();
                    doc.text(102, i, ":");                     
                    i = i + 3;                    
                };

                linea=  65;                                 // **LINEA 25, 45 (incremento de 20)
                doc.text(93, linea, "Zona Negativa"); 

                doc.text(59, linea+10, "Tolerancia");
                doc.text(110, linea+10, "C");
                doc.text(132, linea+10, "Sensibilidad");

                doc.text(59, linea+13, "extrema");
                doc.text(110, linea+13, "A");
                doc.text(132, linea+13, "prematura");                

                doc.text(59, linea+17, "individualismo");
                doc.text(110, linea+16, "O");
                doc.text(132, linea+17, "experimentación");

                doc.text(59, linea+21, "incontrolado");
                doc.text(110, linea+19, "S");
                doc.text(132, linea+21, "desastroza");
                
                doc.setFontType("bold");                    
                doc.text(36, linea+24, '-------', null, 135);       // Diagonal exterior, superior-izquierdo \, (Columna, fila, texto, null, grados)
                doc.text(181, linea+21, '-------', null, -135);     // Diagonal exterior, superior-derecho /,   (Columna, fila, texto, null, grados)

                /// CUADRANTE A: PLOTEO DEL PUNTO 4
                // ******************************************************************************************
                doc.setFontSize(9);
                doc.setFontType("normal");                          // 1A. GRADA, de arriba a abajo  
                doc.text(36, linea+31, '-------', null, 45);        
                doc.text(171, linea+28, '-------', null, -45);      

                // console.log("AyB, seg1. ",cA_a11,cA_p11,cA_a12,cA_p12,cA_a13,cA_p13,cA_a14,cA_p14,
                //                             cB_a11,cB_p11,cB_a12,cB_p12,cB_a13,cB_p13,cB_a14,cB_p14);
                this.ploteoCuadranteAyBSeg1(doc, cA_a11,cA_p11,cA_a12,cA_p12,cA_a13,cA_p13,cA_a14,cA_p14,
                                            cB_a11,cB_p11,cB_a12,cB_p12,cB_a13,cB_p13,cB_a14,cB_p14);                
                // console.log("AyB, seg2. ",cA_a21,cA_p21,cA_a22,cA_p22,cA_a23,cA_p23,cA_a24,cA_p24,
                //                             cB_a21,cB_p21,cB_a22,cB_p22,cB_a23,cB_p23,cB_a24,cB_p24);
                this.ploteoCuadranteAyBSeg2(doc, cA_a21,cA_p21,cA_a22,cA_p22,cA_a23,cA_p23,cA_a24,cA_p24,
                                            cB_a21,cB_p21,cB_a22,cB_p22,cB_a23,cB_p23,cB_a24,cB_p24);
                // console.log("AyB, seg3. ",cA_a31,cA_p31,cA_a32,cA_p32,cA_a33,cA_p33,cA_a34,cA_p34,
                //                             cB_a31,cB_p31,cB_a32,cB_p32,cB_a33,cB_p33,cB_a34,cB_p34);
                this.ploteoCuadranteAyBSeg3(doc,
                    cA_a31,cA_p31,cA_a32,cA_p32,cA_a33,cA_p33,cA_a34,cA_p34,
                    cB_a31,cB_p31,cB_a32,cB_p32,cB_a33,cB_p33,cB_a34,cB_p34);
                // console.log("AyB, seg4. ",cA_a41,cA_p41,cA_a42,cA_p42,cB_a41,cB_p41,cB_a42,cB_p42);
                this.ploteoCuadranteAyBSeg4(doc,
                    cA_a41,cA_p41,cA_a42,cA_p42,
                    cB_a41,cB_p41,cB_a42,cB_p42);
                            
                /** ................................................................................................................ 
                 *  FRANJA 2 */
                linea= 95;                                  // **LINEA= 55 (incremento de 20)
                doc.text(93, linea, "Zona Positiva"); 

                doc.text(80, linea+8, "Compromiso");
                doc.text(115, linea+8, "Innovación");

                doc.text(25, linea+12, "Participación");
                doc.text(80, linea+12, "moral,");
                doc.text(115, linea+12, "adaptación,");
                doc.text(165, linea+12, "Conveniencia");
                
                doc.text(25, linea+16, "inadecuada,");
                doc.text(80, linea+16, "desarrollo");
                doc.text(115, linea+16, "cambio");
                doc.text(165, linea+16, "política");

                doc.text(25, linea+20, "discusión no,");
                doc.text(80, linea+20, "humano");
                doc.text(165, linea+20, "oportunismo sin,");

                doc.text(25, linea+24, "productiva");
                doc.text(165, linea+24, "principios");

                doc.setFontType("bold");                                    
                doc.setTextColor(0, 0, 255)
                doc.setFontSize(11);                
                doc.text(51,  linea+16, '-------', null, 45);       // 2DA. GRADA, de arriba a abajo
                doc.text(155, linea+14, '-------', null, -45);
                doc.setTextColor(100)
                doc.setFontSize(9);

                doc.setFontType("bold");                                    
                doc.setFontSize(13);          
                
                doc.setFontSize(9);
                doc.setFontType("normal");
                doc.setTextColor(0,0,0)                        
                
                /** ................................................................................................................ 
                 *  FRANJA 3 */
                linea= 135;                                         // **LINEA= 65, 105 (115 - 65= 50 incremento, incremento 30)
                doc.text(66, linea-9,  '-------', null, 45);        // 3ERA. GRADA, de arriba a abajo
                doc.text(140, linea-13, '-------', null, -45);            
                doc.setFontType("bold");                    
                doc.setFontSize(13); 
                doc.setFontSize(9);            
                doc.setFontType("normal");            

                doc.text(45, linea, "Participación,");
                doc.text(139, linea, "Apoyo externo,");

                doc.text(45, linea+5, "franqueza,");
                doc.text(139, linea+5, "adquisición de");

                doc.text(45, linea+10, "discusión");
                doc.text(139, linea+10, "recursos,");

                doc.setFontType("bold");                                    
                doc.setTextColor(0, 0, 255)
                doc.setFontSize(11);                                
                doc.text(79,  linea+4, '-------', null, 45);       // 3A-b. GRADA, de arriba a abajo
                doc.text(125, linea+1, '-------', null, -45);
                doc.setFontType("normal");
                doc.setTextColor(0,0,0)
                doc.setFontSize(9);
                
                doc.text(85,  linea+9, '-------', null, 45);       // 4A. GRADA, de arriba a abajo
                doc.text(119, linea+7, '-------', null, -45);
                                
                doc.text(93, linea+15, "Zona Negativa");
                doc.text(139, linea+15, "crecimiento,");

                /** ................................................................................................................ 
                 *  FRANJA 4 */
                linea=  157;                                    // **LINEA= 117 (incremento de 20)
                doc.text(15, linea, "Apatía");
                doc.text(91, linea, "- Valores no claros");
                doc.text(177, linea, "Beligerancia");

                var zonaDiscontinua=    "......................................................................................................................................................................................................................"
                doc.text(10,linea+2, zonaDiscontinua);
                doc.text(15, linea+6, "Indiferencia");
                doc.text(45, linea+6, "Manejo de");
                doc.text(89, linea+6, "- Valores Opuestos");
                doc.text(139, linea+6, "Productividad");            
                doc.text(177, linea+6, "Hostilidad");

                doc.text(45, linea+12, "información,");
                doc.text(139, linea+12, "logro, impacto");                                        

                doc.text(89,  linea+15, '-------', null, 135);      // 1A. GRADA, del centro al exterior.
                doc.text(122, linea+10, '-------', null, -135);
                this.ploteoCuadranteCyDSeg1(doc,
                    cC_a11,cC_p11,cC_a12,cC_p12,cC_a13,cC_p13,cC_a14,cC_p14,
                    cD_a11,cD_p11,cD_a12,cD_p12,cD_a13,cD_p13,cD_a14,cD_p14);
                this.ploteoCuadranteCyDSeg2(doc,
                    cC_a21,cC_p21,cC_a22,cC_p22,cC_a23,cC_p23,cC_a24,cC_p24,
                    cD_a21,cD_p21,cD_a22,cD_p22,cD_a23,cD_p23,cD_a24,cD_p24);
                this.ploteoCuadranteCyDSeg3(doc,
                    cC_a31,cC_p31,cC_a32,cC_p32,cC_a33,cC_p33,cC_a34,cC_p34,
                    cD_a31,cD_p31,cD_a32,cD_p32,cD_a33,cD_p33,cD_a34,cD_p34);
                this.ploteoCuadranteCyDSeg4(doc,
                    cC_a41,cC_p41,cC_a42,cC_p42,
                    cD_a41,cD_p41,cD_a42,cD_p42,);
            
                doc.setFontType("bold");                                    
                doc.setTextColor(0, 0, 255)
                doc.setFontSize(11);                                
                doc.text(85, linea+20, '-------', null, 135);            // 1Ab. GRADA, del centro al exterior.
                doc.text(128, linea+15, '-------', null, -135);
                doc.setFontType("normal");                                    
                doc.setTextColor(0,0,0)
                doc.setFontSize(9);                                
                
                /** En esta fila NO HAY TEXTO solo las graas y los valores */
                linea= 168;
                doc.text(63, linea+24, '-------', null, 135);            // 2A. GRADA, del centro al exterior.
                doc.text(150, linea+21, '-------', null, -135);

                
                doc.setFontType("bold");                    
                doc.setFontSize(13);                                                        
                doc.setFontSize(9);
                doc.setFontType("normal");            
                
                /** ................................................................................................................ 
                 *  FRANJA 5 */
                linea=  187;                                            // **LINEA= 147 (incremento de 20)
                var columna1=    "Esterelidad de"
                var columna4=    "Esfuerzo"
                doc.text(22, linea+6, columna1);
                doc.text(167, linea+6, columna4);
                doc.setFontType("bold");                                    
                doc.setTextColor(0, 0, 255)
                doc.setFontSize(11);                                                
                doc.text(52, linea+13, '-------', null, 135);            // 4A. GRADA, del centro al exterior.
                doc.text(158, linea+11, '-------', null, -135);
                doc.setFontType("normal");
                doc.setTextColor(0,0,0)
                doc.setFontSize(9);                                

                
                var columna1=    "procedimientos"
                var columna2=    "Estabilidad,"
                var columna3=    "Dirección,"
                var columna4=    "perpeto,"
                doc.text(22, linea+9, columna1);
                doc.text(80, linea+9, columna2);
                doc.text(114, linea+9, columna3);
                doc.text(167, linea+9, columna4);
                doc.setFontType("bold");                    
                doc.setFontSize(13);                        

                doc.setFontSize(9);          
                doc.setFontType("normal");            
                var columna1=    "rigor trivial"
                var columna2=    "control,"
                var columna3=    "claridad de"
                var columna4=    "agotamiento"
                doc.text(22, linea+13, columna1);
                doc.text(80, linea+13, columna2);
                doc.text(114, linea+13, columna3);
                doc.text(167, linea+13, columna4);

                var columna2=    "continuidad"
                var columna3=    "metas,"
                var columna4=    "humano"
                doc.text(80, linea+17, columna2);
                doc.text(114, linea+17, columna3);
                doc.text(167, linea+16, columna4);
                
                var columna3=    "planificación,"
                doc.text(114, linea+21, columna3);

                doc.text(39, linea+28,  '-------', null, 135);                       // 4A. GRADA, del centro al exterior.
                doc.text(173, linea+26, '-------', null, -135);
                
                doc.text(32, linea+28,  '-------', null, -135);                 // DIAGONAL EXTERIOR, cuadrante C
                doc.text(180, linea+38, '-------', null, 135);                  // DIAGONAL EXTERIOR, cuadrante D

                /** ................................................................................................................ 
                 *  FRANJA 6 */                
                linea=  225;                       // **LINEA= 185, 205
                var columna1=    "Perpetuación"
                var columna2=    "R"
                var columna3=    "Regulación,"
                doc.text(60, linea, columna1);
                doc.text(100, linea+4, columna2);
                doc.text(132, linea, columna3);

                var columna1=    "habitual,"
                var columna2=    "i"
                var columna3=    "indiscriminada,"
                doc.text(60, linea+4, columna1);
                doc.text(100, linea+4, columna2);
                doc.text(132, linea+4, columna3);

                var columna1=    "tradicion"
                var columna2=    "g"
                var columna3=    "dogma ciego,"
                doc.text(60, linea+8, columna1);
                doc.text(100, linea+8, columna2);
                doc.text(132, linea+8, columna3);

                var columna1=    "inflexible"
                var columna2=    "i"
                doc.text(60, linea+12, columna1);
                doc.text(100, linea+12, columna2);

                var columna2=    "d"
                doc.text(100, linea+16, columna2);

                var columna2=    "e"
                doc.text(100, linea+19, columna2);

                var columna2=    "z"
                doc.text(100, linea+22, columna2);
                doc.setFontType("bold");                                    
                doc.setFontSize(10);
                doc.text(10, linea+22, "La burocracia"); 
                doc.text(181, linea+22, "Fábrica"); 
                doc.text(13, linea+27, "petrífica"); 
                doc.text(180, linea+27, "opresiva"); 
                doc.setFontType("normal");
                doc.setFontSize(9);

                /** CREACION DEL ARCHIVO PDF */
                var cadena = this.caso.nombre,
                patron = / /g,
                nuevoValor    = "",
                nusuario = cadena.replace(patron,nuevoValor);

                var nArchivo = "Graf_" +  nusuario;
                doc.save(nArchivo);
            } else{

                var miMensajeAlerta= "Debe CARGAR los datos para " + store.state.st_caso.nombre
                if (store.state.st_modo==="INGRESO"){

                    miMensajeAlerta= "Debe INGRESAR información para el nuevo caso"
                }
                alert(miMensajeAlerta)
            } // if()
        }, // crearPDF()
        crearCuad(){

            if (this.caso.r1prom >= 0 && this.caso.r2prom >= 0 &&
                this.caso.r4prom >= 0 && this.caso.r4prom >= 0) {
        
                /** *:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:= 
                 * CUADRANTE A- SEGMENTO 1: del centro hacia afuera. */
                var cA_a11= ""; var cA_p11= ""; var cA_a12= ""; var cA_p12= ""; var cA_a13= ""; var cA_p13= ""; var cA_a14= ""; var cA_p14= "";
                if (this.caso.r1prom <= 3.125) { cA_a11= "*"; cA_p11 = this.caso.r1prom.toString();  } 
                else { if ( this.caso.r1prom >3.125 && this.caso.r1prom<=6.25) { cA_a12= "*"; cA_p12 = this.caso.r1prom.toString();  } 
                    else{  if ( this.caso.r1prom >6.25 && this.caso.r1prom<=9.375) { cA_a13= "*"; cA_p13 = this.caso.r1prom.toString();  } 
                        else if ( this.caso.r1prom >9.375 && this.caso.r1prom<=12.5) { cA_a14= "*"; cA_p14 = this.caso.r1prom.toString(); } 
                    }
                }
                /* CUADRANTE B- SEGMENTO 1: del centro hacia afuera. */
                    var cB_a11= ""; var cB_p11= ""; var cB_a12= ""; var cB_p12= ""; var cB_a13= ""; var cB_p13= ""; var cB_a14= ""; var cB_p14= "";
                    if (this.caso.r2prom <= 3.125) { cB_a11= "*"; cB_p11 = this.caso.r2prom.toString(); } 
                    else {  if ( this.caso.r2prom >3.125 && this.caso.r2prom<=6.25) { cB_a12= "*"; cB_p12 = this.caso.r2prom.toString(); } 
                        else{  if ( this.caso.r2prom >6.25 && this.caso.r2prom<=9.375) { cB_a13= "*"; cB_p13 = this.caso.r2prom.toString();  } 
                            else if ( this.caso.r2prom >9.375 && this.caso.r2prom<=12.5) { cB_a14= "*"; cB_p14 = this.caso.r2prom.toString();  } 
                        }
                    }                
                /* CUADRANTE A- SEGMENTO 2: del centro hacia afuera. */
                var cA_a21= ""; var cA_p21= ""; var cA_a22= ""; var cA_p22= ""; var cA_a23= ""; var cA_p23= ""; var cA_a24= ""; var cA_p24= "";
                if (this.caso.r1prom >12.5 && this.caso.r1prom<=16.88) { cA_a21= "*"; cA_p21 = this.caso.r1prom.toString();  } 
                else { if ( this.caso.r1prom >16.88 && this.caso.r1prom<=21.26) { cA_a22= "*"; cA_p22 = this.caso.r1prom.toString();  } 
                    else{  if ( this.caso.r1prom >21.26 && this.caso.r1prom<=25.63) { cA_a23= "*"; cA_p23 = this.caso.r1prom.toString();  } 
                        else if ( this.caso.r1prom >25.63 && this.caso.r1prom<=30) { cA_a24= "*"; cA_p24 = this.caso.r1prom.toString(); } 
                    }
                }
                /* CUADRANTE B- SEGMENTO 2: del centro hacia afuera. */
                    var cB_a21= ""; var cB_p21= ""; var cB_a22= ""; var cB_p22= ""; var cB_a23= ""; var cB_p23= ""; var cB_a24= ""; var cB_p24= "";
                    if (this.caso.r2prom >12.5 && this.caso.r2prom<=16.88) { cB_a21= "*"; cB_p21 = this.caso.r2prom.toString(); } 
                    else {  if ( this.caso.r2prom >16.88 && this.caso.r2prom<=21.26) { cB_a22= "*"; cB_p22 = this.caso.r2prom.toString(); } 
                        else{  if ( this.caso.r2prom >21.26 && this.caso.r2prom<=25.63) { cB_a23= "*"; cB_p23 = this.caso.r2prom.toString();  } 
                            else if ( this.caso.r2prom >25.63 && this.caso.r2prom<=30) { cB_a24= "*"; cB_p24 = this.caso.r2prom.toString();  } 
                        }
                    }
                    // this.ploteoCuadranteAyBSeg2(doc,
                    //     cA_a21,cA_p21,cA_a22,cA_p22,cA_a23,cA_p23,cA_a24,cA_p24,
                    //     cB_a21,cB_p21,cB_a22,cB_p22,cB_a23,cB_p23,cB_a24,cB_p24);
    
                /** :*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*= */
                /* CUADRANTE B- SEGMENTO 3: del centro hacia afuera. */
                var cA_a31= ""; var cA_p31= ""; var cA_a32= ""; var cA_p32= ""; var cA_a33= ""; var cA_p33= ""; var cA_a34= ""; var cA_p34= "";
                if (this.caso.r1prom >30 && this.caso.r1prom<=32.51) { cA_a31= "*"; cA_p31 = this.caso.r1prom.toString();  } 
                else { if ( this.caso.r1prom >32.51 && this.caso.r1prom<=35.01) { cA_a32= "*"; cA_p32 = this.caso.r1prom.toString();  } 
                    else{  if ( this.caso.r1prom >35.01 && this.caso.r1prom<=37.5) { cA_a33= "*"; cA_p33 = this.caso.r1prom.toString();  } 
                        else if ( this.caso.r1prom >37.5 && this.caso.r1prom<=40) { cA_a34= "*"; cA_p34 = this.caso.r1prom.toString(); } 
                    }
                }
                
                /* CUADRANTE B- SEGMENTO 2: del centro hacia afuera. */
                var cB_a31= ""; var cB_p31= ""; var cB_a32= ""; var cB_p32= ""; var cB_a33= ""; var cB_p33= ""; var cB_a34= ""; var cB_p34= "";
                if (this.caso.r2prom >30 && this.caso.r2prom<=32.51) { cB_a31= "*"; cB_p31 = this.caso.r2prom.toString(); } 
                else {  if ( this.caso.r2prom >32.51 && this.caso.r2prom<=35.01) { cB_a32= "*"; cB_p32 = this.caso.r2prom.toString(); } 
                    else{  if ( this.caso.r2prom >35.01 && this.caso.r2prom<=37.5) { cB_a33= "*"; cB_p33 = this.caso.r2prom.toString();  } 
                        else if ( this.caso.r2prom >37.5 && this.caso.r2prom<=40) { cB_a34= "*"; cB_p34 = this.caso.r2prom.toString();  } 
                    }
                }
                // console.log("en ploteo cA_a34 ? ",cA_a34,", valor ? ",cA_p34);
                
                // this.ploteoCuadranteAyBSeg3(doc,
                //     cA_a31,cA_p31,cA_a32,cA_p32,cA_a33,cA_p33,cA_a34,cA_p34,
                //     cB_a31,cB_p31,cB_a32,cB_p32,cB_a33,cB_p33,cB_a34,cB_p34);                                                
                            /* CUADRANTE B- SEGMENTO 4: del centro hacia afuera. */
                            var cA_a41= ""; var cA_p41= ""; var cA_a42= ""; var cA_p42= ""; var cA_a43= ""; var cA_p43= ""; var cA_a44= ""; var cA_p44= "";
                            if (this.caso.r1prom >40 && this.caso.r1prom<=42.5) { cA_a41= "*"; cA_p41 = this.caso.r1prom.toString();  } 
                            else { 
                                if ( this.caso.r1prom >42.5 ) 
                                    { cA_a42= "*"; cA_p42 = this.caso.r1prom.toString();  } 
                            }    
                            /* CUADRANTE B- SEGMENTO 4: del centro hacia afuera. */
                            var cB_a41= ""; var cB_p41= ""; var cB_a42= ""; var cB_p42= ""; var cB_a43= ""; var cB_p43= ""; var cB_a44= ""; var cB_p44= "";
                            if (this.caso.r2prom >40 && this.caso.r2prom<=42.5) { cB_a41= "*"; cB_p41 = this.caso.r2prom.toString();  } 
                            else { 
                                if ( this.caso.r2prom >42.5 ) 
                                    { cB_a42= "*"; cB_p42 = this.caso.r1prom.toString();  } 
                            }    
                            // console.log("fuera de ploteo, ",cA_a41,cA_p41,cA_a42,cA_p42,cB_a41,cB_p41,cB_a42,cB_p42);                    
                            // this.ploteoCuadranteAyBSeg4(doc,
                            //     cA_a41,cA_p41,cA_a42,cA_p42,
                            //     cB_a41,cB_p41,cB_a42,cB_p42);
            
            /* -*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*                            
            /* CUADRANTE C- SEGMENTO 1: del centro hacia afuera. */
            // this.caso.r1prom= 11.5;
            var cC_a11= ""; var cC_p11= ""; var cC_a12= ""; var cC_p12= ""; var cC_a13= ""; var cC_p13= ""; var cC_a14= ""; var cC_p14= "";
            if (this.caso.r3prom <= 3.125) { cC_a11= "*"; cC_p11 = this.caso.r3prom.toString();  } 
            else { if ( this.caso.r3prom >3.125 && this.caso.r3prom<=6.25) { cC_a11= "*"; cC_p12 = this.caso.r3prom.toString();  } 
                else{  if ( this.caso.r3prom >6.25 && this.caso.r3prom<=9.375) { cC_a13= "*"; cC_p13 = this.caso.r3prom.toString();  } 
                    else if ( this.caso.r3prom >9.375 && this.caso.r3prom<=12.5) { cC_a14= "*"; cC_p14 = this.caso.r3prom.toString(); } 
                }
            }
            
            /* CUADRANTE D- SEGMENTO 1: del centro hacia afuera. */
            // this.caso.r2prom= 11.5;                
            var cD_a11= ""; var cD_p11= ""; var cD_a12= ""; var cD_p12= ""; var cD_a13= ""; var cD_p13= ""; var cD_a14= ""; var cD_p14= "";
            if (this.caso.r4prom <= 3.125) { cD_a11= "*"; cD_p11 = this.caso.r4prom.toString(); } 
            else {  if ( this.caso.r4prom >3.125 && this.caso.r4prom<=6.25) { cD_a12= "*"; cD_p12 = this.caso.r4prom.toString(); } 
                else{  if ( this.caso.r4prom >6.25 && this.caso.r4prom<=9.375) { cD_a13= "*"; cD_p13 = this.caso.r4prom.toString();  } 
                    else if ( this.caso.r4prom >9.375 && this.caso.r4prom<=12.5) { cD_a14= "*"; cD_p14 = this.caso.r4prom.toString();  } 
                }
            }
                    /* CUADRANTE C- SEGMENTO 2: del centro hacia afuera. */
                    // this.caso.r1prom= 11.5;
                    var cC_a21= ""; var cC_p21= ""; var cC_a22= ""; var cC_p22= ""; var cC_a23= ""; var cC_p23= ""; var cC_a24= ""; var cC_p24= "";
                    if (this.caso.r3prom >12.5 && this.caso.r3prom<=16.88) { cC_a21= "*"; cC_p21 = this.caso.r3prom.toString();  } 
                    else { if ( this.caso.r3prom >16.88 && this.caso.r3prom<=21.26) { cC_a21= "*"; cC_p22 = this.caso.r3prom.toString();  } 
                        else{  if ( this.caso.r3prom >21.26 && this.caso.r3prom<=25.63) { cC_a23= "*"; cC_p23 = this.caso.r3prom.toString();  } 
                            else if ( this.caso.r3prom >25.63 && this.caso.r3prom<=30) { cC_a24= "*"; cC_p24 = this.caso.r3prom.toString(); } 
                        }
                    }
                    /* CUADRANTE D- SEGMENTO 2: del centro hacia afuera. */
                    // this.caso.r2prom= 11.5;                
                    var cD_a21= ""; var cD_p21= ""; var cD_a22= ""; var cD_p22= ""; var cD_a23= ""; var cD_p23= ""; var cD_a24= ""; var cD_p24= "";
                    if (this.caso.r4prom >12.5 && this.caso.r4prom<=16.88) { cD_a21= "*"; cD_p21 = this.caso.r4prom.toString(); } 
                    else {  if ( this.caso.r4prom >16.88 && this.caso.r4prom<=21.26) { cD_a22= "*"; cD_p22 = this.caso.r4prom.toString(); } 
                        else{  if ( this.caso.r4prom >21.26 && this.caso.r4prom<=25.63) { cD_a23= "*"; cD_p23 = this.caso.r4prom.toString();  } 
                            else if ( this.caso.r4prom >25.63 && this.caso.r4prom<=30) { cD_a24= "*"; cD_p24 = this.caso.r4prom.toString();  } 
                        }
                    }
                    // console.log("> prom 4 ? ",this.caso.r4prom,"* cC_a32 ? ",cD_a23,", valor ? ",cD_p23);
                    // console.log("> prom 4 ? ",this.caso.r4prom,"* cC_a32 ? ",cD_a24,", valor ? ",cD_p24);

            /* CUADRANTE D- SEGMENTO 1: del centro hacia afuera. */
            var cC_a31= ""; var cC_p31= ""; var cC_a32= ""; var cC_p32= ""; var cC_a33= ""; var cC_p33= ""; var cC_a34= ""; var cC_p34= "";
            if (this.caso.r3prom >30 && this.caso.r3prom<=32.51) { cC_a31= "*"; cC_p31 = this.caso.r3prom.toString();  } 
            else { if ( this.caso.r3prom >32.51 && this.caso.r3prom<=35.01) { cC_a32= "*"; cC_p32 = this.caso.r3prom.toString();  } 
                else{  if ( this.caso.r3prom >35.01 && this.caso.r3prom<=37.5) { cC_a33= "*"; cC_p33 = this.caso.r3prom.toString();  } 
                    else if ( this.caso.r3prom >37.5 && this.caso.r3prom<=40) { cC_a34= "*"; cC_p34 = this.caso.r3prom.toString(); } 
                }
            }
            // console.log("prom 4 ? ",this.caso.r4prom,"* cC_a32 ? ",cC_a33,", valor ? ",cC_p33);
            
            /* CUADRANTE D- SEGMENTO 2: del centro hacia afuera. */
            var cD_a31= ""; var cD_p31= ""; var cD_a32= ""; var cD_p32= ""; var cD_a33= ""; var cD_p33= ""; var cD_a34= ""; var cD_p34= "";
            if (this.caso.r4prom >30 && this.caso.r4prom<=32.51) { cD_a31= "*"; cD_p31 = this.caso.r4prom.toString(); } 
            else {  if ( this.caso.r4prom >32.51 && this.caso.r4prom<=35.01) { cD_a32= "*"; cD_p32 = this.caso.r4prom.toString(); } 
                else{  if ( this.caso.r4prom >35.01 && this.caso.r4prom<=37.5) { cD_a33= "*"; cD_p33 = this.caso.r4prom.toString();  } 
                    else if ( this.caso.r4prom >37.5 && this.caso.r4prom<=40) { cD_a34= "*"; cD_p34 = this.caso.r4prom.toString();  } 
                }
            }
            // console.log("prom 4 ? ",this.caso.r4prom,"* cC_a32 ? ",cD_a33,", valor ? ",cD_p33);

            /* CUADRANTE D- SEGMENTO 3: del centro hacia afuera. */
            var cC_a41= ""; var cC_p41= ""; var cC_a42= ""; var cC_p42= ""; 
            if (this.caso.r3prom >40 && this.caso.r3prom<=42.5) { cC_a41= "*"; cC_p41 = this.caso.r3prom.toString();  } 
            else { 
                if ( this.caso.r3prom >42.5 ) 
                    { cC_a42= "*"; cC_p42 = this.caso.r3prom.toString();  } 
            }
            /* CUADRANTE D- SEGMENTO 4: del centro hacia afuera. */
            var cD_a41= ""; var cD_p41= ""; var cD_a42= ""; var cD_p42= "";
            if (this.caso.r4prom >40 && this.caso.r4prom<=42.5) { cD_a41= "*"; cD_p41 = this.caso.r4prom.toString();  } 
            else { 
                if ( this.caso.r4prom >42.5 ) 
                    { cD_a42= "*"; cD_p42 = this.caso.r4prom.toString();  } 
            }    

            // console.log("prom3 ? ",this.caso.r3prom,", prom4 ? ",this.caso.r4prom);
                                        
                /** Codificación de la imagen que representa el logotipo de Top Consultores */
                var imagen= "data:image/jpeg;base64,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";
                var doc =   new jsPDF('portrait');
                var linea=  5;

                /** Muestra el logo. (izq, top, ancho, alto) */
                doc.addImage(imagen, 'JPEG', 165, linea, 40, 20);
                /** fila, columna */

                /** CIRCULOS  */
                doc.setLineWidth(1);                    // Grosor de la línea del borde
                doc.setDrawColor(0);

                /** ................................................................................................................ 
                /* TEXTO INTRODUCTORIO */
                let meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
                
                var lhoy = new Date();                
                //lhoy=   lhoy.toString();
                var ldia=   lhoy.getDate();
                var lmes=   meses[ lhoy.getMonth() ];
                var lanio=  lhoy.getFullYear();

                // console.log("lhoy ? ",lhoy);
                // console.log("ldia ? ",ldia,", lmes ? ",lmes,", lanio ? ",lanio);
                doc.setFontSize(9);    
                linea=25;
                doc.text(10,linea,"Ciudad de Guatemala, "+ldia+" de "+lmes+" de "+lanio);
                doc.text(10,linea+7,this.caso.nombre)
                doc.text(10,linea+12,this.caso.empresa)
                doc.text(10,linea+19,"");
                doc.text(10,linea+24,"");

                /** ................................................................................................................ 
                /* GRAFICA */
                
                /* El circulo rojo EXTERIOR. (left, bottom, tamaño) */
                // linea= 155;                             // **LINEA= 115, 135
                // doc.setFillColor(247,189,164);          // Color rosadito
                // doc.circle(105, linea, 95, 'FD');       // Ciculo

                // /* El circulo azul INTERIOR. (left, bottom, tamaño)*/
                // doc.setFillColor(177,203,233);          // Color azul
                // doc.circle(104, linea, 70, 'FD');

                // /* El circulo rosado INTERIOR. (left, bottom, tamaño) */
                // doc.setFillColor(247,189,164);          // Color rosadito
                // doc.circle(104, linea, 30, 'FD');
                
                /** ................................................................................................................ 
                 *  FRANJA 1 */ 
                /** Extremo Iquierdo y derecho SUPERIOR */
                linea= 60
                doc.setFontType("bold");                                    
                doc.setFontSize(10);
                doc.text(10, linea, "El Irresponsable"); 
                doc.text(182, linea, "Anarquía"); 
                doc.text(10, linea+5, "Club Campestre"); 
                doc.text(180, linea+5, "tumultuosa"); 
                doc.setFontType("normal");
                doc.setFontSize(9);

                var i=63;
                while (i<=250){

                    let st = ":"+i.toString();
                    doc.text(102, i, ":");                     
                    i = i + 3;                    
                };

                linea=  65;                                 // **LINEA 25, 45 (incremento de 20)
                doc.text(93, linea, "Zona Negativa"); 

                doc.text(59, linea+10, "Tolerancia");
                doc.text(110, linea+10, "C");
                doc.text(132, linea+10, "Sensibilidad");

                doc.text(59, linea+13, "extrema");
                doc.text(110, linea+13, "A");
                doc.text(132, linea+13, "prematura");                

                doc.text(59, linea+17, "individualismo");
                doc.text(110, linea+16, "O");
                doc.text(132, linea+17, "experimentación");

                doc.text(59, linea+21, "incontrolado");
                doc.text(110, linea+19, "S");
                doc.text(132, linea+21, "desastroza");
                
                doc.setFontType("bold");                    
                doc.text(36, linea+24, '-------', null, 135);       // Diagonal exterior, superior-izquierdo \, (Columna, fila, texto, null, grados)
                doc.text(181, linea+21, '-------', null, -135);     // Diagonal exterior, superior-derecho /,   (Columna, fila, texto, null, grados)

                /// CUADRANTE A: PLOTEO DEL PUNTO 4
                // ******************************************************************************************
                doc.setFontSize(9);
                doc.setFontType("normal");                          // 1A. GRADA, de arriba a abajo  
                doc.text(36, linea+31, '-------', null, 45);        
                doc.text(171, linea+28, '-------', null, -45);      

                // console.log("AyB, seg1. ",cA_a11,cA_p11,cA_a12,cA_p12,cA_a13,cA_p13,cA_a14,cA_p14,
                //                             cB_a11,cB_p11,cB_a12,cB_p12,cB_a13,cB_p13,cB_a14,cB_p14);
                this.ploteoCuadranteAyBSeg1(doc, cA_a11,cA_p11,cA_a12,cA_p12,cA_a13,cA_p13,cA_a14,cA_p14,
                                            cB_a11,cB_p11,cB_a12,cB_p12,cB_a13,cB_p13,cB_a14,cB_p14);                
                // console.log("AyB, seg2. ",cA_a21,cA_p21,cA_a22,cA_p22,cA_a23,cA_p23,cA_a24,cA_p24,
                //                             cB_a21,cB_p21,cB_a22,cB_p22,cB_a23,cB_p23,cB_a24,cB_p24);
                this.ploteoCuadranteAyBSeg2(doc, cA_a21,cA_p21,cA_a22,cA_p22,cA_a23,cA_p23,cA_a24,cA_p24,
                                            cB_a21,cB_p21,cB_a22,cB_p22,cB_a23,cB_p23,cB_a24,cB_p24);
                // console.log("AyB, seg3. ",cA_a31,cA_p31,cA_a32,cA_p32,cA_a33,cA_p33,cA_a34,cA_p34,
                //                             cB_a31,cB_p31,cB_a32,cB_p32,cB_a33,cB_p33,cB_a34,cB_p34);
                this.ploteoCuadranteAyBSeg3(doc,
                    cA_a31,cA_p31,cA_a32,cA_p32,cA_a33,cA_p33,cA_a34,cA_p34,
                    cB_a31,cB_p31,cB_a32,cB_p32,cB_a33,cB_p33,cB_a34,cB_p34);
                // console.log("AyB, seg4. ",cA_a41,cA_p41,cA_a42,cA_p42,cB_a41,cB_p41,cB_a42,cB_p42);
                this.ploteoCuadranteAyBSeg4(doc,
                    cA_a41,cA_p41,cA_a42,cA_p42,
                    cB_a41,cB_p41,cB_a42,cB_p42);
                            
                /** ................................................................................................................ 
                 *  FRANJA 2 */
                linea= 95;                                  // **LINEA= 55 (incremento de 20)
                doc.text(93, linea, "Zona Positiva"); 

                doc.text(80, linea+8, "Compromiso");
                doc.text(115, linea+8, "Innovación");

                doc.text(25, linea+12, "Participación");
                doc.text(80, linea+12, "moral,");
                doc.text(115, linea+12, "adaptación,");
                doc.text(165, linea+12, "Conveniencia");
                
                doc.text(25, linea+16, "inadecuada,");
                doc.text(80, linea+16, "desarrollo");
                doc.text(115, linea+16, "cambio");
                doc.text(165, linea+16, "política");

                doc.text(25, linea+20, "discusión no,");
                doc.text(80, linea+20, "humano");
                doc.text(165, linea+20, "oportunismo sin,");

                doc.text(25, linea+24, "productiva");
                doc.text(165, linea+24, "principios");

                doc.setFontType("bold");                                    
                doc.setTextColor(0, 0, 255)
                doc.setFontSize(11);                
                doc.text(51,  linea+16, '-------', null, 45);       // 2DA. GRADA, de arriba a abajo
                doc.text(155, linea+14, '-------', null, -45);
                doc.setTextColor(100)
                doc.setFontSize(9);

                doc.setFontType("bold");                                    
                doc.setFontSize(13);          
                
                doc.setFontSize(9);
                doc.setFontType("normal");
                doc.setTextColor(0,0,0)                        
                
                /** ................................................................................................................ 
                 *  FRANJA 3 */
                linea= 135;                                         // **LINEA= 65, 105 (115 - 65= 50 incremento, incremento 30)
                doc.text(66, linea-9,  '-------', null, 45);        // 3ERA. GRADA, de arriba a abajo
                doc.text(140, linea-13, '-------', null, -45);            
                doc.setFontType("bold");                    
                doc.setFontSize(13); 
                doc.setFontSize(9);            
                doc.setFontType("normal");            

                doc.text(45, linea, "Participación,");
                doc.text(139, linea, "Apoyo externo,");

                doc.text(45, linea+5, "franqueza,");
                doc.text(139, linea+5, "adquisición de");

                doc.text(45, linea+10, "discusión");
                doc.text(139, linea+10, "recursos,");

                doc.setFontType("bold");                                    
                doc.setTextColor(0, 0, 255)
                doc.setFontSize(11);                                
                doc.text(79,  linea+4, '-------', null, 45);       // 3A-b. GRADA, de arriba a abajo
                doc.text(125, linea+1, '-------', null, -45);
                doc.setFontType("normal");
                doc.setTextColor(0,0,0)
                doc.setFontSize(9);
                
                doc.text(85,  linea+9, '-------', null, 45);       // 4A. GRADA, de arriba a abajo
                doc.text(119, linea+7, '-------', null, -45);
                                
                doc.text(93, linea+15, "Zona Negativa");
                doc.text(139, linea+15, "crecimiento,");

                /** ................................................................................................................ 
                 *  FRANJA 4 */
                linea=  157;                                    // **LINEA= 117 (incremento de 20)
                doc.text(15, linea, "Apatía");
                doc.text(91, linea, "- Valores no claros");
                doc.text(177, linea, "Beligerancia");

                var zonaDiscontinua=    "......................................................................................................................................................................................................................"
                doc.text(10,linea+2, zonaDiscontinua);
                doc.text(15, linea+6, "Indiferencia");
                doc.text(45, linea+6, "Manejo de");
                doc.text(89, linea+6, "- Valores Opuestos");
                doc.text(139, linea+6, "Productividad");            
                doc.text(177, linea+6, "Hostilidad");

                doc.text(45, linea+12, "información,");
                doc.text(139, linea+12, "logro, impacto");                                        

                doc.text(89,  linea+15, '-------', null, 135);      // 1A. GRADA, del centro al exterior.
                doc.text(122, linea+10, '-------', null, -135);
                this.ploteoCuadranteCyDSeg1(doc,
                    cC_a11,cC_p11,cC_a12,cC_p12,cC_a13,cC_p13,cC_a14,cC_p14,
                    cD_a11,cD_p11,cD_a12,cD_p12,cD_a13,cD_p13,cD_a14,cD_p14);
                this.ploteoCuadranteCyDSeg2(doc,
                    cC_a21,cC_p21,cC_a22,cC_p22,cC_a23,cC_p23,cC_a24,cC_p24,
                    cD_a21,cD_p21,cD_a22,cD_p22,cD_a23,cD_p23,cD_a24,cD_p24);
                this.ploteoCuadranteCyDSeg3(doc,
                    cC_a31,cC_p31,cC_a32,cC_p32,cC_a33,cC_p33,cC_a34,cC_p34,
                    cD_a31,cD_p31,cD_a32,cD_p32,cD_a33,cD_p33,cD_a34,cD_p34);
                this.ploteoCuadranteCyDSeg4(doc,
                    cC_a41,cC_p41,cC_a42,cC_p42,
                    cD_a41,cD_p41,cD_a42,cD_p42,);
            
                doc.setFontType("bold");                                    
                doc.setTextColor(0, 0, 255)
                doc.setFontSize(11);                                
                doc.text(85, linea+20, '-------', null, 135);            // 1Ab. GRADA, del centro al exterior.
                doc.text(128, linea+15, '-------', null, -135);
                doc.setFontType("normal");                                    
                doc.setTextColor(0,0,0)
                doc.setFontSize(9);                                
                
                /** En esta fila NO HAY TEXTO solo las graas y los valores */
                linea= 168;
                doc.text(63, linea+24, '-------', null, 135);            // 2A. GRADA, del centro al exterior.
                doc.text(150, linea+21, '-------', null, -135);

                
                doc.setFontType("bold");                    
                doc.setFontSize(13);                                                        
                doc.setFontSize(9);
                doc.setFontType("normal");            
                
                /** ................................................................................................................ 
                 *  FRANJA 5 */
                linea=  187;                                            // **LINEA= 147 (incremento de 20)
                var columna1=    "Esterelidad de"
                var columna4=    "Esfuerzo"
                doc.text(22, linea+6, columna1);
                doc.text(167, linea+6, columna4);
                doc.setFontType("bold");                                    
                doc.setTextColor(0, 0, 255)
                doc.setFontSize(11);                                                
                doc.text(52, linea+13, '-------', null, 135);            // 4A. GRADA, del centro al exterior.
                doc.text(158, linea+11, '-------', null, -135);
                doc.setFontType("normal");
                doc.setTextColor(0,0,0)
                doc.setFontSize(9);                                

                
                var columna1=    "procedimientos"
                var columna2=    "Estabilidad,"
                var columna3=    "Dirección,"
                var columna4=    "perpeto,"
                doc.text(22, linea+9, columna1);
                doc.text(80, linea+9, columna2);
                doc.text(114, linea+9, columna3);
                doc.text(167, linea+9, columna4);
                doc.setFontType("bold");                    
                doc.setFontSize(13);                        

                doc.setFontSize(9);          
                doc.setFontType("normal");            
                var columna1=    "rigor trivial"
                var columna2=    "control,"
                var columna3=    "claridad de"
                var columna4=    "agotamiento"
                doc.text(22, linea+13, columna1);
                doc.text(80, linea+13, columna2);
                doc.text(114, linea+13, columna3);
                doc.text(167, linea+13, columna4);

                var columna2=    "continuidad"
                var columna3=    "metas,"
                var columna4=    "humano"
                doc.text(80, linea+17, columna2);
                doc.text(114, linea+17, columna3);
                doc.text(167, linea+16, columna4);
                
                var columna3=    "planificación,"
                doc.text(114, linea+21, columna3);

                doc.text(39, linea+28,  '-------', null, 135);                       // 4A. GRADA, del centro al exterior.
                doc.text(173, linea+26, '-------', null, -135);
                
                doc.text(32, linea+28,  '-------', null, -135);                 // DIAGONAL EXTERIOR, cuadrante C
                doc.text(180, linea+38, '-------', null, 135);                  // DIAGONAL EXTERIOR, cuadrante D

                /** ................................................................................................................ 
                 *  FRANJA 6 */                
                linea=  225;                       // **LINEA= 185, 205
                var columna1=    "Perpetuación"
                var columna2=    "R"
                var columna3=    "Regulación,"
                doc.text(60, linea, columna1);
                doc.text(100, linea+4, columna2);
                doc.text(132, linea, columna3);

                var columna1=    "habitual,"
                var columna2=    "i"
                var columna3=    "indiscriminada,"
                doc.text(60, linea+4, columna1);
                doc.text(100, linea+4, columna2);
                doc.text(132, linea+4, columna3);

                var columna1=    "tradicion"
                var columna2=    "g"
                var columna3=    "dogma ciego,"
                doc.text(60, linea+8, columna1);
                doc.text(100, linea+8, columna2);
                doc.text(132, linea+8, columna3);

                var columna1=    "inflexible"
                var columna2=    "i"
                doc.text(60, linea+12, columna1);
                doc.text(100, linea+12, columna2);

                var columna2=    "d"
                doc.text(100, linea+16, columna2);

                var columna2=    "e"
                doc.text(100, linea+19, columna2);

                var columna2=    "z"
                doc.text(100, linea+22, columna2);
                doc.setFontType("bold");                                    
                doc.setFontSize(10);
                doc.text(10, linea+22, "La burocracia"); 
                doc.text(181, linea+22, "Fábrica"); 
                doc.text(13, linea+27, "petrífica"); 
                doc.text(180, linea+27, "opresiva"); 
                doc.setFontType("normal");
                doc.setFontSize(9);

                /** CREACION DEL ARCHIVO PDF */
                var cadena = this.caso.nombre,
                patron = / /g,
                nuevoValor    = "",
                nusuario = cadena.replace(patron,nuevoValor);
                var nArchivo = "Cuad_" +  nusuario;
                doc.save(nArchivo);
            } else{

                var miMensajeAlerta= "Debe CARGAR los datos para " + store.state.st_caso.nombre
                if (store.state.st_modo==="INGRESO"){

                    miMensajeAlerta= "Debe INGRESAR información para el nuevo caso"
                }
                alert(miMensajeAlerta)
            } // if()
        }, // crearCuad()
        melida(){

            if (this.caso.r1prom >= 0 && this.caso.r2prom >= 0 &&
                this.caso.r4prom >= 0 && this.caso.r4prom >= 0) {
        
                /** *:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:=*:= 
                 * CUADRANTE A- SEGMENTO 1: del centro hacia afuera. */
                var cA_a11= ""; var cA_p11= ""; var cA_a12= ""; var cA_p12= ""; var cA_a13= ""; var cA_p13= ""; var cA_a14= ""; var cA_p14= "";
                if (this.caso.r1prom <= 3.125) { cA_a11= "*"; cA_p11 = this.caso.r1prom.toString();  } 
                else { if ( this.caso.r1prom >3.125 && this.caso.r1prom<=6.25) { cA_a12= "*"; cA_p12 = this.caso.r1prom.toString();  } 
                    else{  if ( this.caso.r1prom >6.25 && this.caso.r1prom<=9.375) { cA_a13= "*"; cA_p13 = this.caso.r1prom.toString();  } 
                        else if ( this.caso.r1prom >9.375 && this.caso.r1prom<=12.5) { cA_a14= "*"; cA_p14 = this.caso.r1prom.toString(); } 
                    }
                }
                /* CUADRANTE B- SEGMENTO 1: del centro hacia afuera. */
                    var cB_a11= ""; var cB_p11= ""; var cB_a12= ""; var cB_p12= ""; var cB_a13= ""; var cB_p13= ""; var cB_a14= ""; var cB_p14= "";
                    if (this.caso.r2prom <= 3.125) { cB_a11= "*"; cB_p11 = this.caso.r2prom.toString(); } 
                    else {  if ( this.caso.r2prom >3.125 && this.caso.r2prom<=6.25) { cB_a12= "*"; cB_p12 = this.caso.r2prom.toString(); } 
                        else{  if ( this.caso.r2prom >6.25 && this.caso.r2prom<=9.375) { cB_a13= "*"; cB_p13 = this.caso.r2prom.toString();  } 
                            else if ( this.caso.r2prom >9.375 && this.caso.r2prom<=12.5) { cB_a14= "*"; cB_p14 = this.caso.r2prom.toString();  } 
                        }
                    }                
                /* CUADRANTE A- SEGMENTO 2: del centro hacia afuera. */
                var cA_a21= ""; var cA_p21= ""; var cA_a22= ""; var cA_p22= ""; var cA_a23= ""; var cA_p23= ""; var cA_a24= ""; var cA_p24= "";
                if (this.caso.r1prom >12.5 && this.caso.r1prom<=16.88) { cA_a21= "*"; cA_p21 = this.caso.r1prom.toString();  } 
                else { if ( this.caso.r1prom >16.88 && this.caso.r1prom<=21.26) { cA_a22= "*"; cA_p22 = this.caso.r1prom.toString();  } 
                    else{  if ( this.caso.r1prom >21.26 && this.caso.r1prom<=25.63) { cA_a23= "*"; cA_p23 = this.caso.r1prom.toString();  } 
                        else if ( this.caso.r1prom >25.63 && this.caso.r1prom<=30) { cA_a24= "*"; cA_p24 = this.caso.r1prom.toString(); } 
                    }
                }
                /* CUADRANTE B- SEGMENTO 2: del centro hacia afuera. */
                    var cB_a21= ""; var cB_p21= ""; var cB_a22= ""; var cB_p22= ""; var cB_a23= ""; var cB_p23= ""; var cB_a24= ""; var cB_p24= "";
                    if (this.caso.r2prom >12.5 && this.caso.r2prom<=16.88) { cB_a21= "*"; cB_p21 = this.caso.r2prom.toString(); } 
                    else {  if ( this.caso.r2prom >16.88 && this.caso.r2prom<=21.26) { cB_a22= "*"; cB_p22 = this.caso.r2prom.toString(); } 
                        else{  if ( this.caso.r2prom >21.26 && this.caso.r2prom<=25.63) { cB_a23= "*"; cB_p23 = this.caso.r2prom.toString();  } 
                            else if ( this.caso.r2prom >25.63 && this.caso.r2prom<=30) { cB_a24= "*"; cB_p24 = this.caso.r2prom.toString();  } 
                        }
                    }
                    // this.ploteoCuadranteAyBSeg2(doc,
                    //     cA_a21,cA_p21,cA_a22,cA_p22,cA_a23,cA_p23,cA_a24,cA_p24,
                    //     cB_a21,cB_p21,cB_a22,cB_p22,cB_a23,cB_p23,cB_a24,cB_p24);
    
                /** :*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*=:*= */
                /* CUADRANTE B- SEGMENTO 3: del centro hacia afuera. */
                var cA_a31= ""; var cA_p31= ""; var cA_a32= ""; var cA_p32= ""; var cA_a33= ""; var cA_p33= ""; var cA_a34= ""; var cA_p34= "";
                if (this.caso.r1prom >30 && this.caso.r1prom<=32.51) { cA_a31= "*"; cA_p31 = this.caso.r1prom.toString();  } 
                else { if ( this.caso.r1prom >32.51 && this.caso.r1prom<=35.01) { cA_a32= "*"; cA_p32 = this.caso.r1prom.toString();  } 
                    else{  if ( this.caso.r1prom >35.01 && this.caso.r1prom<=37.5) { cA_a33= "*"; cA_p33 = this.caso.r1prom.toString();  } 
                        else if ( this.caso.r1prom >37.5 && this.caso.r1prom<=40) { cA_a34= "*"; cA_p34 = this.caso.r1prom.toString(); } 
                    }
                }
                
                /* CUADRANTE B- SEGMENTO 2: del centro hacia afuera. */
                var cB_a31= ""; var cB_p31= ""; var cB_a32= ""; var cB_p32= ""; var cB_a33= ""; var cB_p33= ""; var cB_a34= ""; var cB_p34= "";
                if (this.caso.r2prom >30 && this.caso.r2prom<=32.51) { cB_a31= "*"; cB_p31 = this.caso.r2prom.toString(); } 
                else {  if ( this.caso.r2prom >32.51 && this.caso.r2prom<=35.01) { cB_a32= "*"; cB_p32 = this.caso.r2prom.toString(); } 
                    else{  if ( this.caso.r2prom >35.01 && this.caso.r2prom<=37.5) { cB_a33= "*"; cB_p33 = this.caso.r2prom.toString();  } 
                        else if ( this.caso.r2prom >37.5 && this.caso.r2prom<=40) { cB_a34= "*"; cB_p34 = this.caso.r2prom.toString();  } 
                    }
                }
                // console.log("en ploteo cA_a34 ? ",cA_a34,", valor ? ",cA_p34);
                
                // this.ploteoCuadranteAyBSeg3(doc,
                //     cA_a31,cA_p31,cA_a32,cA_p32,cA_a33,cA_p33,cA_a34,cA_p34,
                //     cB_a31,cB_p31,cB_a32,cB_p32,cB_a33,cB_p33,cB_a34,cB_p34);                                                
                            /* CUADRANTE B- SEGMENTO 4: del centro hacia afuera. */
                            var cA_a41= ""; var cA_p41= ""; var cA_a42= ""; var cA_p42= ""; var cA_a43= ""; var cA_p43= ""; var cA_a44= ""; var cA_p44= "";
                            if (this.caso.r1prom >40 && this.caso.r1prom<=42.5) { cA_a41= "*"; cA_p41 = this.caso.r1prom.toString();  } 
                            else { 
                                if ( this.caso.r1prom >42.5 ) 
                                    { cA_a42= "*"; cA_p42 = this.caso.r1prom.toString();  } 
                            }    
                            /* CUADRANTE B- SEGMENTO 4: del centro hacia afuera. */
                            var cB_a41= ""; var cB_p41= ""; var cB_a42= ""; var cB_p42= ""; var cB_a43= ""; var cB_p43= ""; var cB_a44= ""; var cB_p44= "";
                            if (this.caso.r2prom >40 && this.caso.r2prom<=42.5) { cB_a41= "*"; cB_p41 = this.caso.r2prom.toString();  } 
                            else { 
                                if ( this.caso.r2prom >42.5 ) 
                                    { cB_a42= "*"; cB_p42 = this.caso.r1prom.toString();  } 
                            }    
                            // console.log("fuera de ploteo, ",cA_a41,cA_p41,cA_a42,cA_p42,cB_a41,cB_p41,cB_a42,cB_p42);                    
                            // this.ploteoCuadranteAyBSeg4(doc,
                            //     cA_a41,cA_p41,cA_a42,cA_p42,
                            //     cB_a41,cB_p41,cB_a42,cB_p42);
            
            /* -*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*                            
            /* CUADRANTE C- SEGMENTO 1: del centro hacia afuera. */
            // this.caso.r1prom= 11.5;
            var cC_a11= ""; var cC_p11= ""; var cC_a12= ""; var cC_p12= ""; var cC_a13= ""; var cC_p13= ""; var cC_a14= ""; var cC_p14= "";
            if (this.caso.r3prom <= 3.125) { cC_a11= "*"; cC_p11 = this.caso.r3prom.toString();  } 
            else { if ( this.caso.r3prom >3.125 && this.caso.r3prom<=6.25) { cC_a11= "*"; cC_p12 = this.caso.r3prom.toString();  } 
                else{  if ( this.caso.r3prom >6.25 && this.caso.r3prom<=9.375) { cC_a13= "*"; cC_p13 = this.caso.r3prom.toString();  } 
                    else if ( this.caso.r3prom >9.375 && this.caso.r3prom<=12.5) { cC_a14= "*"; cC_p14 = this.caso.r3prom.toString(); } 
                }
            }
            
            /* CUADRANTE D- SEGMENTO 1: del centro hacia afuera. */
            // this.caso.r2prom= 11.5;                
            var cD_a11= ""; var cD_p11= ""; var cD_a12= ""; var cD_p12= ""; var cD_a13= ""; var cD_p13= ""; var cD_a14= ""; var cD_p14= "";
            if (this.caso.r4prom <= 3.125) { cD_a11= "*"; cD_p11 = this.caso.r4prom.toString(); } 
            else {  if ( this.caso.r4prom >3.125 && this.caso.r4prom<=6.25) { cD_a12= "*"; cD_p12 = this.caso.r4prom.toString(); } 
                else{  if ( this.caso.r4prom >6.25 && this.caso.r4prom<=9.375) { cD_a13= "*"; cD_p13 = this.caso.r4prom.toString();  } 
                    else if ( this.caso.r4prom >9.375 && this.caso.r4prom<=12.5) { cD_a14= "*"; cD_p14 = this.caso.r4prom.toString();  } 
                }
            }
                    /* CUADRANTE C- SEGMENTO 2: del centro hacia afuera. */
                    // this.caso.r1prom= 11.5;
                    var cC_a21= ""; var cC_p21= ""; var cC_a22= ""; var cC_p22= ""; var cC_a23= ""; var cC_p23= ""; var cC_a24= ""; var cC_p24= "";
                    if (this.caso.r3prom >12.5 && this.caso.r3prom<=16.88) { cC_a21= "*"; cC_p21 = this.caso.r3prom.toString();  } 
                    else { if ( this.caso.r3prom >16.88 && this.caso.r3prom<=21.26) { cC_a21= "*"; cC_p22 = this.caso.r3prom.toString();  } 
                        else{  if ( this.caso.r3prom >21.26 && this.caso.r3prom<=25.63) { cC_a23= "*"; cC_p23 = this.caso.r3prom.toString();  } 
                            else if ( this.caso.r3prom >25.63 && this.caso.r3prom<=30) { cC_a24= "*"; cC_p24 = this.caso.r3prom.toString(); } 
                        }
                    }
                    /* CUADRANTE D- SEGMENTO 2: del centro hacia afuera. */
                    // this.caso.r2prom= 11.5;                
                    var cD_a21= ""; var cD_p21= ""; var cD_a22= ""; var cD_p22= ""; var cD_a23= ""; var cD_p23= ""; var cD_a24= ""; var cD_p24= "";
                    if (this.caso.r4prom >12.5 && this.caso.r4prom<=16.88) { cD_a21= "*"; cD_p21 = this.caso.r4prom.toString(); } 
                    else {  if ( this.caso.r4prom >16.88 && this.caso.r4prom<=21.26) { cD_a22= "*"; cD_p22 = this.caso.r4prom.toString(); } 
                        else{  if ( this.caso.r4prom >21.26 && this.caso.r4prom<=25.63) { cD_a23= "*"; cD_p23 = this.caso.r4prom.toString();  } 
                            else if ( this.caso.r4prom >25.63 && this.caso.r4prom<=30) { cD_a24= "*"; cD_p24 = this.caso.r4prom.toString();  } 
                        }
                    }
                    // console.log("> prom 4 ? ",this.caso.r4prom,"* cC_a32 ? ",cD_a23,", valor ? ",cD_p23);
                    // console.log("> prom 4 ? ",this.caso.r4prom,"* cC_a32 ? ",cD_a24,", valor ? ",cD_p24);

            /* CUADRANTE D- SEGMENTO 1: del centro hacia afuera. */
            var cC_a31= ""; var cC_p31= ""; var cC_a32= ""; var cC_p32= ""; var cC_a33= ""; var cC_p33= ""; var cC_a34= ""; var cC_p34= "";
            if (this.caso.r3prom >30 && this.caso.r3prom<=32.51) { cC_a31= "*"; cC_p31 = this.caso.r3prom.toString();  } 
            else { if ( this.caso.r3prom >32.51 && this.caso.r3prom<=35.01) { cC_a32= "*"; cC_p32 = this.caso.r3prom.toString();  } 
                else{  if ( this.caso.r3prom >35.01 && this.caso.r3prom<=37.5) { cC_a33= "*"; cC_p33 = this.caso.r3prom.toString();  } 
                    else if ( this.caso.r3prom >37.5 && this.caso.r3prom<=40) { cC_a34= "*"; cC_p34 = this.caso.r3prom.toString(); } 
                }
            }
            // console.log("prom 4 ? ",this.caso.r4prom,"* cC_a32 ? ",cC_a33,", valor ? ",cC_p33);
            
            /* CUADRANTE D- SEGMENTO 2: del centro hacia afuera. */
            var cD_a31= ""; var cD_p31= ""; var cD_a32= ""; var cD_p32= ""; var cD_a33= ""; var cD_p33= ""; var cD_a34= ""; var cD_p34= "";
            if (this.caso.r4prom >30 && this.caso.r4prom<=32.51) { cD_a31= "*"; cD_p31 = this.caso.r4prom.toString(); } 
            else {  if ( this.caso.r4prom >32.51 && this.caso.r4prom<=35.01) { cD_a32= "*"; cD_p32 = this.caso.r4prom.toString(); } 
                else{  if ( this.caso.r4prom >35.01 && this.caso.r4prom<=37.5) { cD_a33= "*"; cD_p33 = this.caso.r4prom.toString();  } 
                    else if ( this.caso.r4prom >37.5 && this.caso.r4prom<=40) { cD_a34= "*"; cD_p34 = this.caso.r4prom.toString();  } 
                }
            }
            // console.log("prom 4 ? ",this.caso.r4prom,"* cC_a32 ? ",cD_a33,", valor ? ",cD_p33);

            /* CUADRANTE D- SEGMENTO 3: del centro hacia afuera. */
            var cC_a41= ""; var cC_p41= ""; var cC_a42= ""; var cC_p42= ""; 
            if (this.caso.r3prom >40 && this.caso.r3prom<=42.5) { cC_a41= "*"; cC_p41 = this.caso.r3prom.toString();  } 
            else { 
                if ( this.caso.r3prom >42.5 ) 
                    { cC_a42= "*"; cC_p42 = this.caso.r3prom.toString();  } 
            }
            /* CUADRANTE D- SEGMENTO 4: del centro hacia afuera. */
            var cD_a41= ""; var cD_p41= ""; var cD_a42= ""; var cD_p42= "";
            if (this.caso.r4prom >40 && this.caso.r4prom<=42.5) { cD_a41= "*"; cD_p41 = this.caso.r4prom.toString();  } 
            else { 
                if ( this.caso.r4prom >42.5 ) 
                    { cD_a42= "*"; cD_p42 = this.caso.r4prom.toString();  } 
            }    

            // console.log("prom3 ? ",this.caso.r3prom,", prom4 ? ",this.caso.r4prom);
                                        
                /** Codificación de la imagen que representa el logotipo de Top Consultores */
                var imagen= "data:image/jpeg;base64,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";
                var doc =   new jsPDF('portrait');
                var linea=  5;

                /** Muestra el logo. (izq, top, ancho, alto) */
                doc.addImage(imagen, 'JPEG', 165, linea, 40, 20);
                /** fila, columna */

                /** CIRCULOS  */
                doc.setLineWidth(1);                    // Grosor de la línea del borde
                doc.setDrawColor(0);

                /** ................................................................................................................ 
                /* TEXTO INTRODUCTORIO */
                let meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
                
                var lhoy = new Date();                
                //lhoy=   lhoy.toString();
                var ldia=   lhoy.getDate();
                var lmes=   meses[ lhoy.getMonth() ];
                var lanio=  lhoy.getFullYear();

                // console.log("lhoy ? ",lhoy);
                // console.log("ldia ? ",ldia,", lmes ? ",lmes,", lanio ? ",lanio);
                doc.setFontType("bold");
                doc.setFontSize(10);
                linea=25;
                doc.text(10,linea,"CARACTERIZACION DE CULTURA");
                doc.setFontType("normal");
                doc.setFontSize(9);

                // doc.text(10,linea,"Ciudad de Guatemala, "+ldia+" de "+lmes+" de "+lanio);
                // doc.text(10,linea+7,this.caso.nombre)
                // doc.text(10,linea+12,this.caso.empresa)
                // doc.text(10,linea+19,"");
                // doc.text(10,linea+24,"");

                /** ................................................................................................................ 
                /* GRAFICA */
                
                /* El circulo rojo EXTERIOR. (left, bottom, tamaño) */
                linea= 155;                             // **LINEA= 115, 135
                doc.setFillColor(247,189,164);          // Color rosadito
                doc.circle(105, linea, 95, 'FD');       // Ciculo

                /* El circulo azul INTERIOR. (left, bottom, tamaño)*/
                doc.setFillColor(177,203,233);          // Color azul
                doc.circle(104, linea, 70, 'FD');

                /* El circulo rosado INTERIOR. (left, bottom, tamaño) */
                doc.setFillColor(247,189,164);          // Color rosadito
                doc.circle(104, linea, 30, 'FD');
                
                /** ................................................................................................................ 
                 *  FRANJA 1 */ 
                /** Extremo Iquierdo y derecho SUPERIOR */
                linea= 60
                doc.setFontType("bold");                                    
                doc.setFontSize(10);
                doc.text(10, linea, "RRHH"); 
                doc.text(182, linea, "MERCADO"); 
                // doc.text(10, linea+5, "Club Campestre"); 
                // doc.text(180, linea+5, "tumultuosa"); 
                doc.setFontType("normal");
                doc.setFontSize(9);

                var i=63;
                while (i<=250){

                    let st = ":"+i.toString();
                    doc.text(102, i, ":");                     
                    i = i + 3;                    
                };

                linea=  65;                                 // **LINEA 25, 45 (incremento de 20)
                doc.text(93, linea, "Zona Negativa"); 

                doc.text(59, linea+10, "Tolerancia");
                doc.text(110, linea+10, "C");
                doc.text(132, linea+10, "Sensibilidad");

                doc.text(59, linea+13, "extrema");
                doc.text(110, linea+13, "A");
                doc.text(132, linea+13, "prematura");                

                doc.text(59, linea+17, "individualismo");
                doc.text(110, linea+16, "O");
                doc.text(132, linea+17, "experimentación");

                doc.text(59, linea+21, "incontrolado");
                doc.text(110, linea+19, "S");
                doc.text(132, linea+21, "desastroza");
                
                doc.setFontType("bold");                    
                doc.text(36, linea+24, '-------', null, 135);       // Diagonal exterior, superior-izquierdo \, (Columna, fila, texto, null, grados)
                doc.text(181, linea+21, '-------', null, -135);     // Diagonal exterior, superior-derecho /,   (Columna, fila, texto, null, grados)

                /// CUADRANTE A: PLOTEO DEL PUNTO 4
                // ******************************************************************************************
                doc.setFontSize(9);
                doc.setFontType("normal");                          // 1A. GRADA, de arriba a abajo  
                doc.text(36, linea+31, '-------', null, 45);        
                doc.text(171, linea+28, '-------', null, -45);      

                // console.log("AyB, seg1. ",cA_a11,cA_p11,cA_a12,cA_p12,cA_a13,cA_p13,cA_a14,cA_p14,
                //                             cB_a11,cB_p11,cB_a12,cB_p12,cB_a13,cB_p13,cB_a14,cB_p14);
                this.ploteoCuadranteAyBSeg1(doc, cA_a11,cA_p11,cA_a12,cA_p12,cA_a13,cA_p13,cA_a14,cA_p14,
                                            cB_a11,cB_p11,cB_a12,cB_p12,cB_a13,cB_p13,cB_a14,cB_p14);                
                // console.log("AyB, seg2. ",cA_a21,cA_p21,cA_a22,cA_p22,cA_a23,cA_p23,cA_a24,cA_p24,
                //                             cB_a21,cB_p21,cB_a22,cB_p22,cB_a23,cB_p23,cB_a24,cB_p24);
                this.ploteoCuadranteAyBSeg2(doc, cA_a21,cA_p21,cA_a22,cA_p22,cA_a23,cA_p23,cA_a24,cA_p24,
                                            cB_a21,cB_p21,cB_a22,cB_p22,cB_a23,cB_p23,cB_a24,cB_p24);
                // console.log("AyB, seg3. ",cA_a31,cA_p31,cA_a32,cA_p32,cA_a33,cA_p33,cA_a34,cA_p34,
                //                             cB_a31,cB_p31,cB_a32,cB_p32,cB_a33,cB_p33,cB_a34,cB_p34);
                this.ploteoCuadranteAyBSeg3(doc,
                    cA_a31,cA_p31,cA_a32,cA_p32,cA_a33,cA_p33,cA_a34,cA_p34,
                    cB_a31,cB_p31,cB_a32,cB_p32,cB_a33,cB_p33,cB_a34,cB_p34);
                // console.log("AyB, seg4. ",cA_a41,cA_p41,cA_a42,cA_p42,cB_a41,cB_p41,cB_a42,cB_p42);
                this.ploteoCuadranteAyBSeg4(doc,
                    cA_a41,cA_p41,cA_a42,cA_p42,
                    cB_a41,cB_p41,cB_a42,cB_p42);
                            
                /** ................................................................................................................ 
                 *  FRANJA 2 */
                linea= 95;                                  // **LINEA= 55 (incremento de 20)
                doc.text(93, linea, "Zona Positiva"); 

                doc.text(80, linea+8, "Compromiso");
                doc.text(115, linea+8, "Innovación");

                doc.text(25, linea+12, "Participación");
                doc.text(80, linea+12, "moral,");
                doc.text(115, linea+12, "adaptación,");
                doc.text(165, linea+12, "Conveniencia");
                
                doc.text(25, linea+16, "inadecuada,");
                doc.text(80, linea+16, "desarrollo");
                doc.text(115, linea+16, "cambio");
                doc.text(165, linea+16, "política");

                doc.setFontSize(14);
                doc.text(55, linea+20, "55%,");            
                doc.text(140, linea+20, "73%");
                doc.setFontSize(9);

                doc.text(25, linea+20, "discusión no,");
                doc.text(80, linea+20, "humano");
                doc.text(165, linea+20, "oportunismo sin,");

                doc.text(25, linea+24, "productiva");
                doc.text(165, linea+24, "principios");

                doc.setFontType("bold");                                    
                doc.setTextColor(0, 0, 255)
                doc.setFontSize(11);
                doc.text(51,  linea+16, '-------', null, 45);       // 2DA. GRADA, de arriba a abajo
                doc.text(155, linea+14, '-------', null, -45);
                doc.setTextColor(100)
                doc.setFontSize(9);

                doc.setFontType("bold");                                    
                doc.setFontSize(13);          
                
                doc.setFontSize(9);
                doc.setFontType("normal");
                doc.setTextColor(0,0,0)                        
                
                /** ................................................................................................................ 
                 *  FRANJA 3 */
                linea= 135;                                         // **LINEA= 65, 105 (115 - 65= 50 incremento, incremento 30)
                doc.text(66, linea-9,  '-------', null, 45);        // 3ERA. GRADA, de arriba a abajo
                doc.text(140, linea-13, '-------', null, -45);            
                doc.setFontType("bold");                    
                doc.setFontSize(13); 
                doc.setFontSize(9);            
                doc.setFontType("normal");            

                doc.text(45, linea, "Participación,");
                doc.text(139, linea, "Apoyo externo,");

                doc.text(45, linea+5, "franqueza,");
                doc.text(139, linea+5, "adquisición de");

                doc.text(45, linea+10, "discusión");
                doc.text(139, linea+10, "recursos,");

                doc.setFontType("bold");                                    
                doc.setTextColor(0, 0, 255)
                doc.setFontSize(11);                                
                doc.text(79,  linea+4, '-------', null, 45);       // 3A-b. GRADA, de arriba a abajo
                doc.text(125, linea+1, '-------', null, -45);
                doc.setFontType("normal");
                doc.setTextColor(0,0,0)
                doc.setFontSize(9);
                
                doc.text(85,  linea+9, '-------', null, 45);       // 4A. GRADA, de arriba a abajo
                doc.text(119, linea+7, '-------', null, -45);
                                
                doc.setFontSize(14);
                doc.text(81, linea+15, "45%");                
                doc.text(110, linea+10, "27%");
                doc.setFontSize(9);
                
                doc.text(93, linea+15, "Zona Negativa");
                doc.text(139, linea+15, "crecimiento,");

                /** ................................................................................................................ 
                 *  FRANJA 4 */
                linea=  157;                                    // **LINEA= 117 (incremento de 20)
                doc.text(15, linea, "Apatía");
                doc.text(91, linea, "- Valores no claros");
                doc.text(177, linea, "Beligerancia");

                var zonaDiscontinua=    "......................................................................................................................................................................................................................"
                doc.text(10,linea+2, zonaDiscontinua);
                doc.text(15, linea+6, "Indiferencia");
                doc.text(45, linea+6, "Manejo de");
                doc.text(89, linea+6, "- Valores Opuestos");
                doc.text(139, linea+6, "Productividad");            
                doc.text(177, linea+6, "Hostilidad");

                doc.setFontSize(14);
                doc.text(89, linea+18, "9%");                
                doc.setFontSize(9);
                
                doc.text(45, linea+12, "información,");
                doc.text(139, linea+12, "logro, impacto");                                        

                doc.text(89,  linea+15, '-------', null, 135);      // 1A. GRADA, del centro al exterior.
                doc.text(122, linea+10, '-------', null, -135);
                this.ploteoCuadranteCyDSeg1(doc,
                    cC_a11,cC_p11,cC_a12,cC_p12,cC_a13,cC_p13,cC_a14,cC_p14,
                    cD_a11,cD_p11,cD_a12,cD_p12,cD_a13,cD_p13,cD_a14,cD_p14);
                this.ploteoCuadranteCyDSeg2(doc,
                    cC_a21,cC_p21,cC_a22,cC_p22,cC_a23,cC_p23,cC_a24,cC_p24,
                    cD_a21,cD_p21,cD_a22,cD_p22,cD_a23,cD_p23,cD_a24,cD_p24);
                this.ploteoCuadranteCyDSeg3(doc,
                    cC_a31,cC_p31,cC_a32,cC_p32,cC_a33,cC_p33,cC_a34,cC_p34,
                    cD_a31,cD_p31,cD_a32,cD_p32,cD_a33,cD_p33,cD_a34,cD_p34);
                this.ploteoCuadranteCyDSeg4(doc,
                    cC_a41,cC_p41,cC_a42,cC_p42,
                    cD_a41,cD_p41,cD_a42,cD_p42,);
            
                doc.setFontType("bold");                                    
                doc.setTextColor(0, 0, 255)
                doc.setFontSize(11);                                
                doc.text(85, linea+20, '-------', null, 135);            // 1Ab. GRADA, del centro al exterior.
                doc.text(128, linea+15, '-------', null, -135);
                doc.setFontType("normal");                                    
                doc.setTextColor(0,0,0)
                doc.setFontSize(9);                                
                
                /** En esta fila NO HAY TEXTO solo las graas y los valores */
                linea= 168;
                doc.text(63, linea+24, '-------', null, 135);            // 2A. GRADA, del centro al exterior.
                doc.text(150, linea+21, '-------', null, -135);

                
                doc.setFontType("bold");                    
                doc.setFontSize(13);                                                        
                doc.setFontSize(9);
                doc.setFontType("normal");            
                
                /** ................................................................................................................ 
                 *  FRANJA 5 */
                linea=  187;                                            // **LINEA= 147 (incremento de 20)
                doc.setFontSize(14);
                doc.text(63, linea+2, "45.5%");                
                doc.text(139, linea+4, "9%");
                doc.setFontSize(9);                
                var columna1=    "Esterelidad de"
                var columna4=    "Esfuerzo"
                doc.text(22, linea+6, columna1);
                doc.text(167, linea+6, columna4);
                doc.setFontType("bold");                                    
                doc.setTextColor(0, 0, 255)
                doc.setFontSize(11);                                                
                doc.text(52, linea+13, '-------', null, 135);            // 4A. GRADA, del centro al exterior.
                doc.text(158, linea+11, '-------', null, -135);
                doc.setFontType("normal");
                doc.setTextColor(0,0,0)
                doc.setFontSize(9);                                

                
                var columna1=    "procedimientos"
                var columna2=    "Estabilidad,"
                var columna3=    "Dirección,"
                var columna4=    "perpeto,"
                doc.text(22, linea+9, columna1);
                doc.text(80, linea+9, columna2);
                doc.text(114, linea+9, columna3);
                doc.text(167, linea+9, columna4);
                doc.setFontType("bold");                    
                doc.setFontSize(13);                        

                doc.setFontSize(9);          
                doc.setFontType("normal");            
                var columna1=    "rigor trivial"
                var columna2=    "control,"
                var columna3=    "claridad de"
                var columna4=    "agotamiento"
                doc.text(22, linea+13, columna1);
                doc.text(80, linea+13, columna2);
                doc.text(114, linea+13, columna3);
                doc.text(167, linea+13, columna4);

                var columna2=    "continuidad"
                var columna3=    "metas,"
                var columna4=    "humano"
                doc.text(80, linea+17, columna2);
                doc.text(114, linea+17, columna3);
                doc.text(167, linea+16, columna4);
                
                var columna3=    "planificación,"
                doc.text(114, linea+21, columna3);

                doc.text(39, linea+28,  '-------', null, 135);                       // 4A. GRADA, del centro al exterior.
                doc.text(173, linea+26, '-------', null, -135);
                
                doc.text(32, linea+28,  '-------', null, -135);                 // DIAGONAL EXTERIOR, cuadrante C
                doc.text(180, linea+38, '-------', null, 135);                  // DIAGONAL EXTERIOR, cuadrante D

                /** ................................................................................................................ 
                 *  FRANJA 6 */                
                linea=  225;                       // **LINEA= 185, 205
                doc.setFontSize(14);
                doc.text(38, linea-12, "45.5%");
                doc.text(159, linea-10, "91%");
                doc.setFontSize(9);                                
                var columna1=    "Perpetuación"
                var columna2=    "R"
                var columna3=    "Regulación,"
                doc.text(60, linea, columna1);
                doc.text(100, linea+4, columna2);
                doc.text(132, linea, columna3);

                var columna1=    "habitual,"
                var columna2=    "i"
                var columna3=    "indiscriminada,"
                doc.text(60, linea+4, columna1);
                doc.text(100, linea+4, columna2);
                doc.text(132, linea+4, columna3);

                var columna1=    "tradicion"
                var columna2=    "g"
                var columna3=    "dogma ciego,"
                doc.text(60, linea+8, columna1);
                doc.text(100, linea+8, columna2);
                doc.text(132, linea+8, columna3);

                var columna1=    "inflexible"
                var columna2=    "i"
                doc.text(60, linea+12, columna1);
                doc.text(100, linea+12, columna2);

                var columna2=    "d"
                doc.text(100, linea+16, columna2);

                var columna2=    "e"
                doc.text(100, linea+19, columna2);

                var columna2=    "z"
                doc.text(100, linea+22, columna2);
                doc.setFontType("bold");
                doc.setFontSize(10);
                doc.text(10, linea+22, "PROCESOS"); 
                doc.text(186, linea+22, "METAS"); 
                doc.text(11, linea+27, "INTERNOS"); 
                doc.text(180, linea+27, "RACIONALES"); 
                doc.setFontType("normal");
                doc.setFontSize(9);

                /** CREACION DEL ARCHIVO PDF */
                var cadena = this.caso.nombre,
                patron = / /g,
                nuevoValor    = "",
                nusuario = cadena.replace(patron,nuevoValor);
                var nArchivo = "Resumen";
                doc.save(nArchivo);
            } else{

                var miMensajeAlerta= "Debe CARGAR los datos para " + store.state.st_caso.nombre
                if (store.state.st_modo==="INGRESO"){

                    miMensajeAlerta= "Debe INGRESAR información para el nuevo caso"
                }
                alert(miMensajeAlerta)
            } // if()
        }, // melida()                
    }, // methods    
} // export



// WEBPACK FOOTER //
// ./src/components/culturaGforma.js